const events = [
  {
    id: "711221A",
    title: "The Youngs become grandparents",
    date: new Date("12/21/1971"),
    location: "Malibu",
    description: {
      text: "|The Malibu Times| reported the birth of David Aaron Lemley, the first son of Emily and Steven Lemley and the first grandchild of Norvel and Helen Young.<1> Just a few months later, new father Steven would be announced as associate dean of student life on the Malibu campus.\nToday, David serves as a professor in Seaver's religion department.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13384/rec/695",
          title: "The Malibu Times",
          date: "1/14/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ['administration'],
    seeAlso: {
      people: ['Steven Lemley', 'M. Norvel Young', 'Helen Young'],
      events: ['720811A'],
    },
  },
  {
    id: "711231A",
    title: "Howard A. White moves in near Trancas",
    date: new Date("12/31/1971"),
    location: "Malibu",
    description: {
      text: "At the end of 1971, executive vice president Howard A. White became one of the first Pepperdiners to move to Malibu, in advance of the opening of the Malibu campus in September 1972. The Whites' home was on Paseo Canyon Drive, near Trancas.<1>\nWhite would go on to be Pepperdine's fifth president, serving from 1978-1985.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/11477/rec/693",
          title: "The Malibu Times",
          date: "12/31/71",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ['administration'],
    seeAlso: {
      people: ["Howard A. White"],
      events: [],
    },
  },
  {
    id: "720107A",
    title: "Walter Glass raises flag on campus every day",
    date: new Date("1/7/1972"),
    location: "Malibu",
    description: {
      text: "A letter to the editor of |The Malibu Times| praised the \"majestic elegance\" of the 100-foot flagpole erected in 1968 below today's Brock House. In answer to the letter writer's question about the flag, the |Times| specified that Pepperdine physical education instructor Walter Glass was responsible for raising and lowering the flag every day.<1> Glass was one of the first Pepperdiners (and perhaps the first member of the faculty) to move to Malibu in advance of the opening of the new campus in September 1972. Glass's wife Betty sewed the flag's fraying edges, calling herself \"the Pepperdine Betsy Ross.\"<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13525/rec/694",
          title: "The Malibu Times",
          date: "1/7/72",
          publisher: "Pepperdine University Archives",
          page: "10",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "179-80",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["Walter Glass"],
      events: [],
    },
  },
  {
    id: "720108B",
    title: "Freshmen allowed to play varsity basketball",
    date: new Date("1/8/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "The NCAA approved a rule change that would allow freshmen to play varsity basketball and football. The rule was set to take effect for the 1972-1973 season. Pepperdine men's basketball coach (and athletic director) Gary Colson said he was in favor of the change. UCLA coach John Wooden opposed the new rule, saying, \"It takes a boy a year to get adjusted or oriented to college life.\"<1>\nThe rule change came too late to benefit William \"Bird\" Averitt, who was in the middle of a tremendous 1971-1972 season as a sophomore after sitting out as a freshman. The Waves would benefit from the rule change in the 1972-1973 season with contributions from two freshman bigs.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9881/rec/61",
          title: "The Graphic",
          date: "1/13/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/105/rec/7",
          title: "Inner View",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "8",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["Gary Colson", "William \"Bird\" Averitt"],
      events: [],
    },
  },
  {
    id: "720113D",
    title: "Stephen Parmelee makes the dean's list",
    date: new Date("1/13/1972 15:00:00"),
    location: "LA campus",
    description: {
      text: `The Dean's list was announced for the fall 1971 term. Among the students honored was Stephen F. Parmelee, (GPA: 3.93), who would go on to be associate professor of English and film at Seaver College.<1>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9880/rec/61",
          title: "The Graphic",
          date: "1/13/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["academics", "student life"],
    seeAlso: {
      people: ["Stephen F. Parmelee"],
      events: [],
    },
  },
  {
    id: "720114A",
    title: "PCH speed limit reduced west of Pepperdine",
    date: new Date("1/14/1972"),
    location: "Malibu",
    description: {
      text: `|The Malibu Times| announced that the speed limit on the Pacific Coast Highway would be reduced from 65mph to 55mph from the Pepperdine site at Malibu Canyon Road west to the Ventura County line. In "business sections" of Malibu, the speed limit would remain at 45mph.<1>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13382/rec/695",
          title: "Malibu Times",
          date: "1/14/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["Malibu"],
    seeAlso: {
      people: [],
      events: [],
    },
  },
  {
    id: "720121A",
    title: "Pat Boone endorses the ERA",
    date: new Date("1/21/1972"),
    location: "LA",
    description: {
      text: "Pop sensation Pat Boone, who had been nearly as big as Elvis in the 1950s, spoke at a rally in favor of the Equal Rights Amendment (ERA) at an event hosted by the Pepperdine chapter of Theta Sigma Phi, an honor society for women in communications.<1>\nThe ERA was a proposed amendment to the Constitution that would guarantee equal rights for citizens regardless of sex. First proposed in 1923, the amendment was approved by the House of Representatives in October 1971 and would be approved by the US Senate in March 1972. The amendment was not ratified by the necessary two-thirds of states before its 1979 deadline and never came into force.\nJanuary 1972 was a busy month for women's lib at Pepperdine. The same week, a petition was presented to executive vice president Howard White asking to change the dress code so women could wear pants.<1>\nIn May, president William Banowsky would come out in support of the Equal Rights amendment, twice taking time on his weekly KNBC program \"The Sunday Show\" to urge its passage.<2>\nPat Boone grew up in the Churches of Christ. His (rocky) affiliation with Pepperdine continued for decades. In 1970, after insisting he could speak in tongues, he was \"disfellowshipped\" by the Inglewood Church of Christ, the home church of many Pepperdine faculty and administrators.<3> In 2008, Boone made a $3 million donation to fund Pepperdine's Boone Center for the Family, which had been founded by Sara Young Jackson.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7194/rec/62",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/239/rec/5",
          title: "The Graphic",
          date: "5/4/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "396",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["politics"],
    seeAlso: {
      people: ["Howard A. White", "William S. Banowsky", "Sara Young Jackson"],
      events: ["720127B", "720210A"],
    },
  },
  {
    id: "720122B",
    title: "Students speak in tongues at retreat",
    date: new Date("1/22/1972 13:00:00"),
    location: "Escondido",
    description: {
      text: `Ten Pepperdine students spoke in tongues at a spiritual retreat near Escondido. The retreat featured speaker Albert Grimes, who founded the Christian Training Center in Bakersfield, CA.<1> |The Graphic|, which called glossolalia "controversial," later ran a piece by Frank Pack, the chair of the religion department, condemning the practice.<2>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7193/rec/62'",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9583/rec/64",
          title: "The Graphic",
          date: "2/10/72",
          publisher: "Pepperdine University Archives",
          page: "6",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["religion", "student life"],
    seeAlso: {
      people: ["Frank Pack"],
      events: ["720210A"],
    },
  },
  {
    id: "720125A",
    title: "Malibu Republican Womens Club tea",
    date: new Date("1/25/1972"),
    location: "Malibu",
    description: {
      text: `|The Malibu Times| reported that a membership tea was held at 3pm. Coffee and tea were poured by Mrs. William Banowsky and Mrs. M. Norvell [sic] Young, the wives of the president and chancellor of Pepperdine, respectively.<1> President Banowsky was heavily involved in Southern California Republican politics, a fact that was not uncontroversial in the Pepperdine community.`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13603/rec/696",
          title: "The Malibu Times",
          date: "1/21/72",
          publisher: "Pepperdine University Archives",
          page: "10",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["events", "politics"],
    seeAlso: {
      people: ["Helen Young", "William S. Banowsky"],
      events: ["720217B"],
    },
  },
  {
    id: "720126A",
    title: "Cafeteria serves steak for dinner",
    date: new Date("1/26/1972"),
    location: "LA campus",
    description: {
      text: `|The Graphic| raved, "It's not a regular habit here to be kind to the cafeteria. But in all fairness, the place outdid itself last night—the steaks were delicious." The quality of the food was a matter of no little complaint among students.<1> The company that provided food service at the LA campus in the winter of 1972 would not have its contract renewed.`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7193/rec/62",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cafeteria","student life"],
    seeAlso: {
      people: [],
      events: ["720209A", "720929A"],
    },
  },
  {
    id: "720127A",
    title: "Faculty request pay raise",
    date: new Date("1/27/72"),
    location: "LA campus",
    description: {
      text: "The Faculty Advisory Committee, chaired by English professor James Smythe, requested a pay raise of more than 5.5% for the 1972-1973 academic year. It would be the first pay increase for the faculty since the 1970-1971 academic year. The 13% increase in the cost of tuition gave the faculty hope that such a raise would be possible. Pepperdine faculty had some of the lowest salaries among the American professoriate, according to the American Association of University Professors (AAUP).<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7194/rec/62",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["faculty"],
    seeAlso: {
      people: ["James Smythe"],
      events: [],
    },
  },
  {
    id: "720127B",
    title: "Women press pants issue",
    date: new Date("1/27/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: `Dean of students Dr. Jennings Davis presented a petition to executive VP Howard A. White, signed by all department heads (including religion chair Frank Pack), proposing that the dress code preventing female employees from wearing pants be eliminated. There was no dress code for male employees. White, who would later become Pepperdine's fifth president, said he would forward the petition to the Board of Trustees, who had had ultimate say over the policy.<1>\nThe dress code had been implemented by Norvel Young, who feared that the school would alienate the churches if it were too permissive. Women students had only received permission to wear pants to class in 1969.<2>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7194/rec/62",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "153",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life"],
    seeAlso: {
      people: ["Jennings Davis", "Howard A. White", "Frank Pack", "M. Norvel Young"],
      events: ["720121A"],
    },
  },
  {
    id: "720127C",
    title: "Social club pledges are hazed",
    date: new Date("1/27/72 14:00:00"),
    location: "LA campus",
    description: {
      text: "|The Graphic|'s report on the annual \"Pledge Week\" for new members of social clubs called the pledges \"worms,\" \"slugs,\" and \"barnacles.\" |The Graphic| called the event \"an annual week of torment for prospects and pleasure for active members\" and recounted pledges of the Kappa Kappa sorority being made to wear sailor outfits and bring toy boats with them everywhere they went. Meanwhile, the Phi Phi Phi fraternity focused on \"psychological indoctrination.\" One pledge, when asked for comment, told the paper, \"You couldn't print it anyway.\"<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7191/rec/62",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life"],
    seeAlso: {
      people: [],
      events: [],
    },
  },
  {
    id: "720203A",
    title: "Randy Lowry wins debate tournament",
    date: new Date("2/3/1972"),
    location: "LA campus",
    description: {
      text: `Sophomore Randy Lowry won the USC-LMU debate tournament with partner Mike Devlin.<1> Lowry would go on to found the Straus Institute for Dispute Resolution at Pepperdine. He later became the seventeenth president of Lipscomb University, Pepperdine's sister school in Nashville.\nLater in 1972, Lowry would be named president of the new student government on the Malibu campus.`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4871/rec/63",
          title: "The Graphic",
          date: "2/3/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life"],
    seeAlso: {
      people: ["Randy Lowry"],
      events: ["720518A"],
    },
  },
  {
    id: "720203B",
    title: "Dean of student life named for Malibu",
    date: new Date("2/3/72 13:00:00"),
    location: "LA campus",
    description: {
      text: "|The Graphic| reported that Bob Thomas had been named the dean of student life for the new Malibu campus, which would open in September 1972. In his new role, Thomas would oversee student recreation, student government, student housing, clubs, chapel, etc. Thomas had been dean of admissions and supervisor of financial aid at the Los Angeles campus.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4870/rec/63",
          title: "The Graphic",
          date: "2/3/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["administration"],
    seeAlso: {
      people: ["Bob Thomas"],
      events: [],
    },
  },
  {
    id: "720204A",
    title: "Graphic wins statewide award",
    date: new Date("2/4/1972"),
    location: "LA campus",
    description: {
      text: `Pepperdine's student newspaper, |The Graphic|, was awarded first place in general excellence from the California Newspaper Publishers Association among four-year college papers with a circulation under 6,000. This was the third consecutive year |The Graphic| won its division. In typical |Graphic| fashion, the article announcing the win misspelled the word "newspaper" as "newpaper."<1>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9584/rec/64",
          title: "The Graphic",
          date: "2/10/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["newspapers", "student life"],
    seeAlso: {
      people: [],
      events: ["720330A"],
      stories: ["S72NEWS"],
    },
  },
  {
    id: "720210A",
    title: "Religion chair responds to glossolalia reports",
    date: new Date("2/10/1972"),
    location: "LA campus",
    description: {
      text: `Frank Pack, the chair of the religion department, was interviewed by |The Graphic| in an article responding to reports<1> that ten Pepperdine students had spoken in tongues at a spiritual retreat near Escondido in January. Pack gives historical context for the way the churches of Christ and the Restoration Movement more broadly thought about glossolalia. He ultimately condemns the practice, citing "a need for careful restudy of scriptures concerning the Holy Spirit" on the part of the Pentecostal movement.<2>\nSpeaking in tongues was a controversial issue in the churches of Christ in the early 1970s. Pop star and Pepperdine donor Pat Boone was "disfellowshipped" from the Inglewood Church of Christ for claiming to speak in tongues in 1970.<3>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7193/rec/62'",
          title: "The Graphic",
          date: "1/27/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9583/rec/64",
          title: "The Graphic",
          date: "2/10/72",
          publisher: "Pepperdine University Archives",
          page: "6",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "396",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["faculty", "religion", "student life"],
    seeAlso: {
      people: ["Frank Pack"],
      events: ["720122B", "720121A"],
    },
  },
  {
    id: "720209A",
    title: "Committee hears cafeteria horrors",
    date: new Date("2/9/1972"),
    location: "LA campus",
    description: {
      text: "At a meeting of the Food and Services committee, student representatives presented a list of complaints about the cafeteria, including \"metal objects in stuffed green peppers\" and \"having fruit drinks stirred by an employee with his bare hand.\" Other complaints came from students who found a band-aid in a salad, bones in jello, and wood-chips in pudding.\nThe committee, which was made up of representatives from administration, the student body, and Szabo (the company that provided food services at the LA campus), agreed to address some complaints, including buying a new dishwasher and ice machine.<1>\nSzabo's contract was not renewed, being passed over in favor of Professional Food Service Management in June 1972.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9584/rec/64",
          title: "The Graphic",
          date: "2/10/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6260/rec/2",
          title: "The Graphic",
          date: "6/22/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cafeteria", "student life"],
    seeAlso: {
      people: [],
      events: ["720126A", "720619A"],
    },
  },
  {
    id: "720217A",
    title: "Racial tensions mount in student senate",
    date: new Date("2/17/1972"),
    location: "LA campus",
    description: {
      text: "The president of the Student Association, Emile Hons, was quoted in a |Graphic| article, saying that there was a \"racial split\" in the student senate. Hons accused a coalition of Black senators of slowing progress on senate finance initiatives by voting to protect the interests of the Black Student Union. One Black sophomore senator shot back that the senate's failure to agree on financial issues was due to Hons's lack of leadership.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2782/rec/65",
          title: "The Graphic",
          date: "2/17/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life", "student government"],
    seeAlso: {
      people: ["Emile Hons"],
      events: ["720508A"],
    },
  },
  {
    id: "720217B",
    title: "Banowsky to chair Nixon campaign in LA",
    date: new Date("2/17/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "Pepperdine president William Banowsky was named the coordinator of the campaign to re-elect president Richard Nixon in LA County, according to reporting in |The Graphic|.<1> He was named to the position by California governor Ronald Reagan.\n|The Graphic| was skeptical of the appointment, expressing in an editorial its concerns that administrators were \"becoming too involved in partisan politics\" and that it posed a \"threat to academic freedom.\" Administrators Jim Wilburn and Jim Mayer had both announced nine-month leaves of absence from their duties at the school to support the re-election campaign.<1>\nBanowsky himself framed his decision as rejecting the \"temptation to remain remote from the real problems of our society.\"<1> His decision probably helped shore up the support of Pepperdine's friends and donors, who skewed conservative, though it did him no favors with donor Blanche Seaver, who disapproved of Nixon.<2>\nIt's unclear whether Banowsky came to regret his involvement in the Nixon campaign, but he writes in his memoir that he regarded \"Mrs. Seaver's conscientious objection to her old friend Nixon\" during the 1972 campaign as, in retrospect, \"a compliment to her character.\"<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2781/rec/65",
          title: "The Graphic",
          date: "2/17/72",
          publisher: "Pepperdine University Archives",
          page: "1, 4",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "328",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "316",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["administration", "politics"],
    seeAlso: {
      people: ["William S. Banowsky", "Blanche E. Seaver"],
      events: ["721107A"],
    },
  },
  {
    id: "720217C",
    title: "Many plan to move to Malibu",
    date: new Date("2/17/1972 14:00:00"),
    location: "LA campus",
    description: {
      text: "In a poll by LA dean of students Jennings Davis, nearly half of polled students living on the LA campus said they would move to the Malibu campus when it opened in the fall. Just 10% of LA students who lived off-campus said they would transition to Malibu. Davis projected a decrease in the number of students living on campus in LA for the next academic year.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2782/rec/65",
          title: "The Graphic",
          date: "2/17/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["housing"],
    seeAlso: {
      people: ["Jennings Davis"],
      events: ["720518B", "720602A", "720720A"],
      stories: ["S72MHSG", "S72LHSG"],
    },
  },
  {
    id: "720218A",
    title: "Asphalt poured for Seaver entrance",
    date: new Date("2/18/1972"),
    location: "Malibu",
    description: {
      text: "|The Graphic| reported that asphalt was due to be poured on what would be the Seaver Drive entrance to the Malibu campus.<1> The guard booth and gate now at the bottom of Seaver Drive were later developments. Before the existence of the road, Civic Center Way dead-ended into Malibu Canyon Road.\nIn fact, before Pepperdine began construction on the Malibu campus, Malibu Canyon Road had no intersection with the Pacific Coast Highway, terminating instead a half-mile north at Civic Center Way. It was only at Pepperdine's request that the county extended Malibu Canyon Road as far as PCH.<2>\nDuring construction, many assumed that Pepperdine's main entrance would be at the new intersection of central Malibu's two main thoroughfares, but president William Banowsky and campus architect William Pereira preferred a subtler side entrance tucked away from the busy highway in Winter Canyon. The grading required for the entrance off Malibu Canyon cost an additional $300,000, which was paid for with Hydril stock donated by Blanche Seaver, after whom the road was named.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2782/rec/65",
          title: "The Graphic",
          date: "2/17/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: 240,
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["William S. Banowsky", "William Pereira", "Blanche E. Seaver"],
      events: ["721117B"],
    },
  },
  {
    id: "720224A",
    title: "Students put on Moliere's Tartuffe",
    date: new Date("2/24/1972"),
    location: "LA campus",
    description: {
      text: "A student production of |Tartuffe|, a comedy by seventeenth-century French playwright Moliere, opened in the auditorium on Pepperdine's LA campus. Tickets were $1 for students, $2 for general admission. The play mocks religious hypocrisy and received a fair review in the Graphic.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1817/rec/66",
          title: "The Graphic",
          date: "2/24/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["arts", "student life"],
    seeAlso: {
      people: [],
      events: ["721013B"],
    },
  },
  {
    id: "720224B",
    title: "Varsity track suspended indefinitely",
    date: new Date("2/24/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "Athletics costs were being cut across the board, but track was the only program to be shuttered.<1> The team had produced 20 All-Americans in the decade preceding its cancellation.<2>\nAthletic director Gary Colson explained that \"It was the only thing we could drop and remain within WCAC guidelines,\"<2> referring to the West Coast Athletic Conference, which dropped \"Athletic\" from its name in 1989.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1818/rec/66",
          title: "The Graphic",
          date: "2/24/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4211/rec/67",
          title: "The Graphic",
          date: "3/2/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["Gary Colson"],
      events: [],
    },
  },
  {
    id: "720227A",
    title: "\"Cagers\" pulled from flight for joke",
    date: new Date("2/27/1972"),
    location: "Seattle?",
    description: {
      text: "Six members of Pepperdine's men's basketball team and coach Gary Colson were pulled from their Western Airlines flight after a stewardess heard one of the players joke about \"taking the plane to Florida.\" The stewardess interpreted the joke as a threat to hijack the flight, and the plane, which was about to take off, was returned to the terminal, where it was met by police and FBI agents. The team caught the next flight out, arriving home about twelve hours later than scheduled.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4208/rec/67",
          title: "The Graphic",
          date: "3/2/72",
          publisher: "Pepperdine University Archives",
          page: "1, 6",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["Gary Colson"],
      events: [],
    },
  },
  {
    id: "720302A",
    title: "Work begins on fieldhouse",
    date: new Date("3/2/1972"),
    location: "Malibu",
    description: {
      text: "The construction of the Firestone Fieldhouse began in March 1972. The building, which would host Pepperdine's basketball and volleyball teams, was largely sponsored by Leonard K. Firestone of Firestone Tires. The fieldhouse was the first part of an athletic village, ultimately to include a pool, tennis courts, a baseball field, and a track.<1>\nOriginally, builders aimed to have the fieldhouse ready in time for the 1972-1973 basketball season, but it wasn't finished until October 1973.<2> Because Firestone was on an ambassadorial appointment to Belgium, the dedication of the facility was delayed until September 20, 1975, when president Gerald Ford drew to campus the largest crowd ever to assemble in Malibu.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8656/rec/68",
          title: "The Graphic",
          date: "3/2/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "298",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "323",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics", "construction"],
    seeAlso: {
      people: ["Leonard K. Firestone"],
      events: [],
    },
  },
  {
    id: "720316A",
    title: "Malibu sewer problems begin",
    date: new Date("3/16/1972"),
    location: "Malibu",
    description: {
      text: "Pepperdine had planned to build a joint water reclamation facility with the neighboring housing development to be built on land owned by the Aluminum Company of America (Alcoa), a neighborhood which today is called Malibu Country Estates.<1> The half-million-dollar facility would no longer be ready in time for the campus's September opening, however, and a new plan for a temporary system of septic tanks was awaiting approval from the county.<2>\nHomeowners in Malibu had long opposed a sewer system in what was at that time an unincorporated part of LA County, preferring to install private septic tanks or cesspools for every home. Just five months earlier, on election day in November 1971, residents of Malibu had voted down a plan to construct a public sewer.<3>\nPepperdine had a strong working relationship with the county board of supervisors, which allowed it to seek permits during the construction phase for projects that generally would require prior approval. |The Graphic| quoted Malibu provost Jerry Hudson as saying, \"Normally, you do these things sequentially, but we are doing them simultaneously.\"<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13734/rec/704",
          title: "The Malibu Times",
          date: "3/17/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8652/rec/68",
          title: "The Graphic",
          date: "3/16/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "293",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "sewer"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: ["720504A", "720507A", "720622A", "720724A", "720815A", "720816A", "721119A", "721129A"],
      stories: ["S72SEWR"],
    },
  },
  {
    id: "720316B",
    title: "Faculty look for housing near Malibu",
    date: new Date("3/16/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "Members of Pepperdine's faculty who planned to teach on the Malibu campus when it opened in the fall were faced with the decision of moving closer to Malibu, or commuting from Los Angeles. Some, including the family of PE professor Walter Glass, had already made the move, but others had yet to decide.\n|The Graphic| reported that the university had plans to build condos for faculty on campus, but that they would not be done in time for the fall (in fact, construction had not even begun and would not be finished for many years).<1> The faculty was not highly compensated, so living in Malibu was out of the question for most. About ten faculty families were already living in new developments near Lake Lindero in what is now Agoura Hills, and others considered moving to Thousand Oaks or Calabasas, where there were schools for their children, though one professor complained that \"there is no major shopping center\" in Thousand Oaks.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8652/rec/68",
          title: "The Graphic",
          date: "3/16/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["faculty", "housing"],
    seeAlso: {
      people: [],
      events: ["720615A"],
      stories: ["S72MHSG"],
    },
  },
  {
    id: "720317A",
    title: "Sara Young injured in accident",
    date: new Date("3/17/72"),
    location: "Malibu",
    description: {
      text: "Sara Young, daughter of Pepperdine chancellor Norvel Young, was a student at sister-school David Lipscomb College in Nashville. During a visit to her parents' home in Malibu, she was injured in a horseback-riding accident. According to the |Malibu Times| report, her \"frisky pony\" threw her off, and she rolled down an embankment, bruising her back but not breaking anything.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13737/rec/113",
          title: "The Malibu Times",
          date: "3/17/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["administration"],
    seeAlso: {
      people: ["Sara Young Jackson", "M. Norvel Young"],
      events: [],
    },
  },
  {
    id: "720323A",
    title: "School of Law to find new campus",
    date: new Date("3/23/1972"),
    location: "Santa Ana",
    description: {
      text: "The Pepperdine School of Law was formed in 1969 when the expanding college took over the Orange University College of Law. The school was at this point outgrowing its facility. According to dean Ronald Phillips, the school was looking for a new home, with an announcement to be made by August, aiming for a 1974 move.<1>\nIn fact, by 1973 the law school had moved from Santa Ana to Anaheim, with a view of Disneyland's Matterhorn ride in the distance. In 1978, after two years of construction, the School of Law moved into the Odell McConnell Law Center on the Malibu campus, where it remains to this day.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4539/rec/69",
          title: "The Graphic",
          date: "3/23/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "250-52",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["graduate schools"],
    seeAlso: {
      people: ["Ronald Phillips"],
      events: ["720915A"],
    },
  },
  {
    id: "720330A",
    title: "Graphic wins All American from ACP",
    date: new Date("3/30/1972"),
    location: "LA campus",
    description: {
      text: "Pepperdine's student newspaper, |The Graphic|, received a rating of All American from the Associated Collegiate Press, the highest honor given.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4207/rec/70",
          title: "The Graphic",
          date: "3/30/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["newspapers", "student life"],
    seeAlso: {
      people: [],
      events: ["720204A"],
      stories: ["S72NEWS"],
    },
  },
  {
    id: "720401B",
    title: "Pereira finalizes tower design",
    date: new Date("4/1/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "Architect William Pereira had gone back and forth with president William Banowsky about the design of Pepperdine's theme tower. The two men agreed about the basics: a 125-foot tall tower (to rival Rio de Janeiro's Christ the Redeemer) atop the most prominent hill near the entrance to the Malibu campus. But that is where their agreements ended.<1>\nPereira preferred an obelisk, to complement his Mediterranean-styled plans for the campus's buildings. Banowsky preferred a cross to honor Pepperdine's Christian heritage. Pereira thought a cross would be trite. Banowsky thought an obelisk would look too much like the Washington Monument.<1>\nThe compromise was proposed by Pereira, whose now familiar design features a tiled cross embedded in an obelisk that is split at the base and tapers toward a pointed tip. Pereira called Banowsky at 5:30am on April Fool's Day to announce his plan.<1>\nPereira's love of the obelisk can also be seen in his design for the Transamerica Pyramid in San Francisco, which was completed in 1972.<1>",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "276-8",
        },
      ],
    },
    photo: {
      path: "/assets/PereiraTower.png",
      caption: "This painting of the Theme Tower was made for the groundbreaking ceremony in April 1972.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/19417/rec/20",
        title: "Sketch of the Phillips Theme Tower",
        date: "1972",
        publisher: "Pepperdine University Archives Photograph Collection",
        page: "",
      },
    },
    event: true,
    tags: ["arts", "construction"],
    seeAlso: {
      people: ["William Pereira", "William S. Banowsky"],
      events: ["720515A", "720517A", "720526A", "720526B", "720531A"],
      stories: ["S72TOWR"]
    },
  },
  {
    id: "720406A",
    title: "New security booth for LA campus",
    date: new Date("4/6/1972"),
    location: "LA campus",
    description: {
      text: "A new security booth was erected at 79th Street and Budlong Avenue on Pepperdine's LA campus. The move came after a \"mild rash of violence\" in the fall 1971 term, including incidents of student harassment. The first impact of the booth was a sudden demand for parking stickers as students felt that parking enforcement was on the rise.<1>\nAmong the guards staffing the booth were student officers working for $1.75 per hour (which was 10% above the federal minimum wage).<1>\nThe Malibu campus would get its own guard booth late in 1972.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/953/rec/71",
          title: "The Graphic",
          date: "4/6/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8604/rec/85",
          title: "The Graphic",
          date: "11/17/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: {
      path: "/assets/Security.png",
      caption: "Student security officer Randy Hodges works at the new guard booth on the LA campus in April 1972.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/953/rec/71",
        title: "The Graphic",
        date: "4/6/1972",
        publisher: "Pepperdine University Archives",
        page: "4",
      },
    },
    event: true,
    tags: ["security"],
    seeAlso: {
      people: [],
      events: ["720501A", "720826A", "721117B"],
      stories: ["S72SECU"]
    },
  },
  {
    id: "720409A",
    title: "Bomb threat at Appleby Center dedication",
    date: new Date("4/9/1972"),
    location: "Malibu",
    description: {
      text: "A bomb threat didn't disturb the crowd of 1,000 that gathered for the dedication of the Jerene Appleby Harnish Center for American Studies, which would serve as the headquarters for the social sciences division on the new Malibu campus.<1> The 25,000-square-foot building, which was only about 60% finished, was funded by a million-dollar donation from Harnish, a newspaper publisher.<1> Authorities were notified of a bomb-threat called in by \"some creep\" who probably \"didn't like Dr. S. I. Hayakawa or the conservatively-oriented Pepperdine,\"<2> but the event proceeded without interruption.\nThe ceremony featured a speech by Hayakawa, the controversial president of San Francisco State College, titled, \"American Tradition in Higher Education.\" Music was provided by the Agoura High School band.<3>\nThe dedication ceremony took place on April 9,<1> not April 24, as Baird says.<4>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/954/rec/71",
          title: "The Graphic",
          date: "4/6/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13208/rec/117",
          title: "The Malibu Times",
          date: "4/14/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13208/rec/117",
          title: "The Malibu Times",
          date: "4/14/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "295",
        },
      ],
    },
    photo: {
      path: "/assets/ApplebyCenter.png",
      caption: "The Appleby Center c. 1973, before the construction of the Weisman Museum or the CAC.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/9609/rec/146",
        title: "Appleby Center for American Studies on Pepperdine University's Malibu campus, circa 1973",
        date: "1973",
        publisher: "Pepperdine University Archives Photograph Collection",
        page: "",
      },
    },
    event: true,
    tags: ["events", "donors"],
    seeAlso: {
      people: ["Jerene Appleby Harnish"],
      events: [],
    },
  },
  {
    id: "720428A",
    title: "Cheerleader named Co-Ed of the Month",
    date: new Date("4/28/1972"),
    location: "LA campus",
    description: {
      text: `Pepperdine cheerleader Karen Bua was named "Co-Ed of the Month" for March by |Coach & Athlete| magazine. |The Malibu Times|, in covering the feature, raved, "WOOOOOOOW, Karen is a REAL page brightener!!!"<1>\nBua would later marry Lakers star Jerry West, who recalls in his memoir meeting her in 1974 and finding her "frankly, one of the most naturally beautiful women I had ever seen."<2>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13254/rec/710",
          title: "The Malibu Times",
          date: "4/28/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "https://www.google.com/books/edition/West_by_West/3rfol8mKr3oC?hl=en&gbpv=1&bsq=bua",
          title: "West by West: My Charmed, Tormented Life",
          date: "2011",
          publisher: "Little, Brown",
          page: "81"
        }
      ],
    },
    photo: {
      path: "/assets/Bua2.jpg",
      caption: "The future Mrs. Jerry West (hiding in a tree for some reason) was the featured co-ed of the month in \"Coach and Athlete\" magazine.",
      source: {
        url: "",
        title: "Coach & Athlete",
        date: "March 1972",
        publisher: "Allen Dees",
        page: "30",
      },
    },
    event: true,
    tags: ["cheerleading", "student life"],
    seeAlso: {
      people: ["Karen Bua"],
      events: ["721110B", "730216A"],
    },
  },
  {
    id: "720501A",
    title: "LA campus locks the gates",
    date: new Date("5/1/1972"),
    location: "LA campus",
    description: {
      text: "LA provost Jack Scott announced a new security policy was being instituted on Pepperdine's LA campus: gates at the entrances to campus would be locked daily at 3pm. The move came as part of an ongoing effort to boost security on campus following some violent crimes in the fall 1971 term. In an attempt to provide a healthy outlet for youth in the neighborhood, Scott also announced a new sports program hosted in the gymnasium.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/236/rec/72",
          title: "The Graphic",
          date: "5/4/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["security"],
    seeAlso: {
      people: [],
      events: ["720406A", "720826A", "721002A"],
      stories: ["S72SECU"]
    },
  },
  {
    id: "720504A",
    title: "Temporary sewer plan denied",
    date: new Date("5/4/1972"),
    location: "Malibu",
    description: {
      text: "Pepperdine's plan for a sewage system was stalled before the county board of supervisors, and construction would take too long for the planned opening in September 1972. It had sought a permit for a temporary system of 38 septic tanks<1> (or perhaps 26; see Banowsky),<2> but the plan was denied and labeled unacceptable \"for any interim whatsoever.\"<1> Faced with this setback, Malibu provost Jerry Hudson remained confident construction would be completed in time for the campus to open.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/236/rec/72",
          title: "The Graphic",
          date: "5/4/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "295",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "sewer"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: ["720316A", "720507A", "720622A", "720724A", "720815A", "720816A", "721119A", "721129A"],
      stories: ["S72SEWR"],
    },
  },
  {
    id: "720507A",
    title: "Malibu to truck sewage to Las Virgenes plant",
    date: new Date("5/7/1972"),
    location: "Malibu",
    description: {
      text: "In an appearance on |The Sunday Show|, a KNBC TV program, President William Banowsky announced a solution to the sewage problems plaguing the construction of the Malibu campus: trucking the campus's raw sewage four miles through Malibu Canyon to a Las Virgenes Municipal Water District plant, where it would be treated.<1>\nThe Tapia water reclamation plant, located near Piuma Road, was already discharging into Malibu Creek as much reclaimed water as it was legally permitted to, so Pepperdine would also have to truck effluent back to campus. Thus, once the sewage trucks reached the plant, they would need to be cleaned, refilled with reclaimed water, and returned to the Malibu campus, to be used to water the landscaping.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1815/rec/73",
          title: "The Graphic",
          date: "5/11/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "295-96",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "sewer"],
    seeAlso: {
      people: ["William S. Banowsky"],
      events: ["720316A", "720504A", "720622A", "720724A", "720815A", "720816A", "721119A", "721129A"],
      stories: ["S72SEWR"],
    },
  },
  {
    id: "720508A",
    title: "Five votes cast in student senate runoff",
    date: new Date("5/8/1972"),
    location: "LA campus",
    description: {
      text: "In a runoff election for the position of sophomore representative in the student senate, a grand total of five votes were cast. The winner won by a margin of four votes to one (either a landslide or a razor-thin margin, depending on your perspective). A third candidate evidently chose not to vote for himself, receiving zero votes.\nA |Graphic| editorial on the matter opined, \"The credibility of the democratic process once again stretched almost to the point of breaking.\" Editors wondered whether the lack of interest was indicative of a general decline in enthusiasm at the Los Angeles campus ahead of the opening of the new college at Malibu.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1814/rec/73",
          title: "The Graphic",
          date: "5/11/72",
          publisher: "Pepperdine University Archives",
          page: "6",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student government", "student life"],
    seeAlso: {
      people: [],
      events: ["720217A"],
    },
  },
  {
    id: "720511A",
    title: "Director of job placement swears he exists",
    date: new Date("5/11/1972"),
    location: "LA campus",
    description: {
      text: "Following a May 4 letter to the editor of |The Graphic| complaining that Pepperdine was the only southern California university without a job placement program, the director of Pepperdine's job placement program responded in a May 11 piece. Dr. W.H. Clinkenbeard (a real name, not a nome de plume) wrote that the school's placement program had existed for 20 years and had a 100% rate of placing interested students into teaching jobs.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/239/rec/72",
          title: "The Graphic",
          date: "5/4/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1814/rec/73",
          title: "The Graphic",
          date: "5/11/72",
          publisher: "Pepperdine University Archives",
          page: "6"
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["academics", "student life"],
    seeAlso: {
      people: [],
      events: [],
    },
  },
  {
    id: "720512A",
    title: "Incompetent campus arsonist convicted",
    date: new Date("5/12/1972"),
    location: "LA campus",
    description: {
      text: "Pepperdine graduate Robert Newton was convicted of \"entering a public building with intent to commit a felony\" and second degree burglary but found not guilty of the arson charges. He was sentenced to three years in jail and a $500 fine.\nThe charges came after fires in two buildings on Pepperdine's LA campus in the fall of 1971. Witnesses said they saw Newton leaving the area after each fire. The fires caused a total of about $200 in damage, and structural damage was only discovered in one building.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/5915/rec/74",
          title: "The Graphic",
          date: "5/18/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life", "security"],
    seeAlso: {
      people: ["Robert Newton"],
      events: [],
      stories: ["S72SECU"]
    },
  },
  {
    id: "720515A",
    title: "Kenneth Hahn approves theme tower",
    date: new Date("5/15/1972"),
    location: "LA",
    description: {
      text: "Pepperdine alumnus Kenneth Hahn was one of five members of the LA County Board of Supervisors, and he was no stranger to using his position to advance Pepperdine's interests, especially when it came to permitting the construction of the Malibu campus. When president William Banowsky and chancellor Norvel Young visited Hahn at his office in downtown Los Angeles in May 1972, they had a big favor to ask.<1>\nTheir plan for a theme tower on the Malibu campus was opposed by Malibu residents, who threatened to tie up construction in the courts even if the county gave it a permit. At this meeting, the group drew up a plan to erect the tower's frame as soon as county approval came through, before neighbors could object.<1>\nHahn agreed to put the item on the board's agenda and shepherd it through the approval process. Banowsky and Young would have the tower's twelve prefabricated steel sections on the ground, ready to bolt together the very night of the board's vote.<1>",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "284-7",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["William S. Banowsky", "M. Norvel Young"],
      events: ["720401A", "720401B", "720517A", "720526A", "720526B"],
      stories: ["S72TOWR"],
    },
  },
  {
    id: "720518A",
    title: "Lowry wins teetotalers' prize",
    date: new Date("5/18/1972"),
    location: "LA campus",
    description: {
      text: "Sophomore Randy Lowry won first place in a speech contest hosted by the Women's Christian Temperance Union. His victory earned him a $150 prize and a trip to Miami in September for the nationals of collegiate oratory.<1>\nLowry would serve as president of the new student government organization on the Malibu campus in the fall of 1972. He later became a professor at the Pepperdine School of Law.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/5912/rec/74",
          title: "The Graphic",
          date: "5/18/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life"],
    seeAlso: {
      people: ["Randy Lowry"],
      events: ["720203A"],
    },
  },
  {
    id: "720518B",
    title: "LA dorms begin emptying out",
    date: new Date("5/18/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "With most residential students moving to the Malibu campus for the fall term, it began to look like the dorms on the LA campus would be mostly empty. Marilyn Hall, a women's dorm capable of housing 200, was expected to host only 100 in the fall. Of three dorms for men with capacity for 175, exactly zero men had requested a room in two of them. Efforts were underway to renovate the dorms to make them more attractive, and some space was being given over to non-residential purposes such as study rooms, game rooms, lounges, etc.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/5914/rec/74",
          title: "The Graphic",
          date: "5/18/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["housing"],
    seeAlso: {
      people: [],
      events: ["720217C", "720720A"],
      stories: ["S72LHSG"],
    },
  },
  {
    id: "720517A",
    title: "Theme tower's foundation poured",
    date: new Date("5/17/1972"),
    location: "Malibu",
    description: {
      text: "Just days before the LA County Board of Supervisors approved the permit, the foundation of Pepperdine's theme tower was poured in preparation for the rushed construction of the tower's frame.<1>\nPresident William Banowsky was worried that opponents of the tower in Malibu would halt progress by legal action if they knew that construction had begun, so he developed a plan with Pepperdine alumnus and county supervisor Kenneth Hahn to pour the foundation before official approval came through, so opponents would have no time to file a law suit.<1>",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "287",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: [],
      events: ["720401A", "720401B", "720515A", "720526A", "720526B"],
      stories: ["S72TOWR"],
    },
  },
  {
    id: "720525A",
    title: "Malibu students object to chapel plans",
    date: new Date("5/25/1972"),
    location: "LA campus",
    description: {
      text: "Students set to attend the Malibu campus were not pleased with the announced plans for chapel on the new campus, according to reporting in |The Graphic|. Bob Thomas, set to become the dean of student life in Malibu, announced that students would have to attend chapel twice a week, \"in keeping with the Malibu concept of education.\"<1>\nA petition signed by about 70% of Malibu pilot program students opposed the plan. Thomas seemed unconcerned by opposition from LA students, noting that they would comprise less than a third of students at Malibu.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6745/rec/75",
          title: "The Graphic",
          date: "5/25/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["religion", "student life"],
    seeAlso: {
      people: ["Bob Thomas"],
      events: [],
    },
  },
  {
    id: "720526A",
    title: "Theme tower permitted by LA County",
    date: new Date("5/26/1972"),
    location: "LA",
    description: {
      text: "The LA County Board of Supervisors approved permits for both the foundation and the construction of Pepperdine's theme tower. As with most votes regarding the construction of the Malibu campus, the vote was 3-2, with Democrat (and Pepperdine alumnus) Kenneth Hahn joining Republicans Warren Dorn and Burton Chase in support.<1>\nUnknown to some supervisors, Pepperdine had in fact already poured the foundation approved that night. Tower construction began immediately upon approval so that opponents of the plan in Malibu would have no time to halt construction by legal action until the frame was already in place.<1>",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "284-7",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: [],
      events: ["720401A", "720401B", "720515A", "720517A", "720526B"],
      stories: ["S72TOWR"],
    },
  },
  {
    id: "720526B",
    title: "Theme tower's superstructure raised",
    date: new Date("5/26/1972 20:00:00"),
    location: "Malibu",
    description: {
      text: "The frame of Pepperdine's theme tower was assembled over the weekend, beginning as soon as the LA County Board of Supervisors approved the permit Friday night. Sections of the steel frame had been trucked to campus from Riverside, and the night of the board's vote, they were bolted together under floodlights, on top of a foundation that had been poured days before it was officially permitted.<1>\nPresident William Banowsky describes the rushed construction in his memoir: \"Monday's sun rose over the Santa Monica Mountains at 6:47 a.m., illuminating the prefabricated steel. Standing in stark 125-foot-tall nakedness, as [architect] Pereira had predicted, it did roughly resemble a poor man's Eiffel Tower.\"<1>\nAlthough the tower's superstructure was raised in May, completion of the project was delayed until September 1973.<2>",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "287",
        },
      ],
    },
    photo: {
      path: "/assets/Phillips.png",
      caption: "The skeleton of the Phillips Theme Tower in March 1973.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1052/rec/96",
        title: "The Graphic",
        date: "3/23/73",
        publisher: "Pepperdine University Archives",
        page: "1",
      },
    },
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["William S. Banowsky", "William Pereira"],
      events: ["720401A", "720401B", "720515A", "720517A", "720526A"],
      stories: ["S72TOWR"]
    },
  },
  {
    id: "720531A",
    title: "Banowsky agrees not to light theme tower",
    date: new Date("5/31/1972"),
    location: "Malibu",
    description: {
      text: "At a meeting with Malibu residents, Pepperdine president William Banowsky agreed not to light the theme tower during his presidency. Opponents of the tower threatened the university with legal action, which would be expensive and delay progress on the campus's construction ahead of its planned opening in September. In exchange for Banowsky's promise not to light the tower during his presidency, Malibuites agreed to discontinue their litigation.<1>\nToward the end of Banowsky's presidency, the tower was lit on several occasions, including during the 1977 holiday season, supposedly without any complaint from the community.<2>",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "288-9",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2693/rec/1",
          title: "The Graphic",
          date: "1/19/78",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: {
      path: "/assets/Lit.png",
      caption: "The Phillips Theme Tower lit, perhaps in the mid '80s.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/1744/rec/8",
        title: "Phillips Theme Tower alight against seascape, mid 1980s",
        date: "mid 1980s",
        publisher: "Pepperdine University Archives Photograph Collection",
        page: "",
      },
    },
    event: true,
    tags: ["construction", "Malibu"],
    seeAlso: {
      people: ["William S. Banowsky"],
      events: ["720401A", "720401B", "720515A", "720517A", "720526A", "720526B"],
    },
  },
  {
    id: "720602A",
    title: "Hudson orders two more dorms built",
    date: new Date("6/2/1972"),
    location: "Malibu",
    description: {
      text: "Facing more housing applications than expected, Malibu provost Jerry Hudson ordered two more dormitories constructed on the Malibu campus. Estimates of residential enrollment for the first semester on the new Malibu campus jumped 50-90% (from 500 to 750-950) in the month before the decision. Each dorm was expected to take four months to build, so these two would not be completed in time for the first semester. Ten other dorms, each with fifty beds, were already under construction and were about halfway finished.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2423/rec/76",
          title: "The Graphic",
          date: "6/8/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: {
      path: "/assets/MalibuHousing.png",
      caption: "Student residences under construction on the Malibu campus in 1972, with Darnell House and Eaton House in the foreground.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/2992/rec/4",
        title: "Student residences under construction, 1972",
        date: "1972",
        publisher: "Pepperdine University Archives Photograph Collection",
        page: "",
      },
    },
    event: true,
    tags: ["construction", "housing"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: ["720217C", "720731A", "720906A"],
      stories: ["S72MHSG"],
    },
  },
  {
    id: "720615A",
    title: "Condos proposed in Topanga Meadows",
    date: new Date("6/15/1972"),
    location: "Malibu",
    description: {
      text: "Pepperdine proposed to build 140 condominiums on 70 acres it owned in Topanga Canyon. The plot, just southwest of Old Topanga Road, had been donated in December 1971 by the widow of Fred Solomon, an early Topanga landowner. Faculty planning on teaching at Malibu were struggling to find affordable housing near the campus, looking as far away as Camarillo.<1> The first faculty condos on the Malibu campus would not be built for many years.\nIn 1973, plans changed from condominiums to single-family detached dwellings.<2> The proposed Topanga units were never built, perhaps due in part to opposition from neighbors.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2934/rec/77",
          title: "The Graphic",
          date: "6/15/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/1052/rec/96",
          title: "The Graphic",
          date: "3/23/73",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["faculty", "housing"],
    seeAlso: {
      people: ["Fred Solomon"],
      events: ["720316B"],
      stories: ["S72MHSG"],
    },
  },
  {
    id: "720616B",
    title: "Trees for Pepperdine Malibu announced",
    date: new Date("6/16/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "|The Malibu Times| reported on Pepperdine's announcement of a $750,000 effort to plant trees to beautify the Malibu campus. The chairman of the Trees for Pepperdine Malibu Committee was Leo Hirsh, who urged donors to sponsor a tree, a grove, or an entire forest.<1>\nThe campus had been stripped of its native chaparral by extensive earthwork in preparation for construction and was in need of landscaping for aesthetic as well as practical purposes like erosion prevention. One brochure said, \"Only God can make a tree, but you can plant a tree at Pepperdine Malibu.\"<2>\nThe project saw some success: in the fall of 1973, the Graphic reported that over a thousand donated trees had been planted around campus, including some 200 Monterey pines between the theme tower and the chapel.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/12844/rec/717",
          title: "The Malibu Times",
          date: "6/16/72",
          publisher: "Pepperdine University Archives",
          page: "12",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "303",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/5228/rec/1",
          title: "The Graphic",
          date: "10/19/1973",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["Leo Hirsh"],
      events: ["720906C", "721103A", "721106A"],
    },
  },
  {
    id: "720622A",
    title: "Pipelines to carry sewage to Tapia plant",
    date: new Date("6/22/1972"),
    location: "Malibu",
    description: {
      text: "In a letter to the Las Virgenes Municipal Water District, Pepperdine proposed running two pipelines through Malibu Canyon to the Tapia water treatment facility near Piuma Road, as a potential solution to its ongoing sewage problem ahead of the planned September opening of the Malibu campus. One pipe would carry sewage to the plant, and the other would carry reclaimed water back to campus to be used for irrigation. |The Graphic| quotes the plant's manager as saying that they had plenty of capacity to accommodate the influx of sewage from Malibu. Piping was proposed as a more pragmatic solution than trucking the sewage, which had previously been considered.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6264/rec/78",
          title: "The Graphic",
          date: "6/22/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "sewer"],
    seeAlso: {
      people: [],
      events: ["720316A", "720504A", "720507A", "720724A", "720815A", "720816A", "721119A", "721129A"],
      stories: ["S72SEWR"],
    },
  },
  {
    id: "720622B",
    title: "Dunphy recruited for volleyball team",
    date: new Date("6/22/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "Pepperdine's men's volleyball coaches announced that Marv Dunphy, the captain of the volleyball team at Pierce College, would join the Waves in the fall.<1> Dunphy would go on to be one of the greatest figures in the history of Pepperdine athletics.\nJoining Dunphy on the team were two new recruits who had been named \"Co-Players of the Year\" by the Southern California High School Volleyball Association, one of whom was quoted in |The Graphic| saying, \"I decided on Pepperdine two years ago when I heard the campus would be located at Malibu Beach, and I didn't give it any more thought.\"<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6262/rec/3",
          title: "The Graphic",
          date: "6/22/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["Marv Dunphy"],
      events: ["721125B"],
    },
  },
  {
    id: "720619A",
    title: "New food service provider named",
    date: new Date("6/19/1972"),
    location: "LA campus",
    description: {
      text: "Professional Food Service Management took over operation of the cafeteria on the LA campus after being named the winner of a new food services contract.<1> The cafeteria was previously operated by Szabo Food Service Company, which was the subject of many student complaints about food quality as well as health and safety.<2> Pepperdine's student-led Food Services Committee took bids from a number of companies, including both Szabo and Professional, and recommended Professional.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6260/rec/2",
          title: "The Graphic",
          date: "6/22/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9584/rec/64",
          title: "The Graphic",
          date: "2/10/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/2418/rec/1",
          title: "The Graphic",
          date: "6/8/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cafeteria"],
    seeAlso: {
      people: [],
      events: ["720209A","720929A"],
    },
  },
  {
    id: "720623A",
    title: "Title IX becomes law",
    date: new Date("6/23/1972"),
    location: "LA campus",
    description: {
      text: "President Richard Nixon signed into law the Education Amendments of 1972, legislation best known for Title IX, which prevented sex-based discrimination in schools receiving federal funds. Although the law makes no mention of athletics, one of its most obvious effects was the creation of women's sports programs at most US high schools and colleges.\nPepperdine did not have officially sponsored intercollegiate sports teams for women in 1972. Women's basketball, volleyball, cross country, and tennis were launched in the mid 70s.",
      sources: [
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics", "politics"],
    seeAlso: {
      people: [],
      events: [],
    },
  },
  {
    id: "720630A",
    title: "Payson receives big collection",
    date: new Date("6/30/1972"),
    location: "Malibu",
    description: {
      text: "|The Malibu Times| reported that Norvel Young had announced the donation of a private collection to Payson Library on the new Malibu campus ahead of its September opening. The collection included some 300,000 volumes, appraised at over $600,000.<1> The books were donated by Harvey Taylor, a book dealer from Santa Barbara. The collection took many months to catalog, stretching well into 1973.<2>\nWhen students on the LA campus heard about this donation, they were not pleased, especially since a substantial portion of their own library's collection was sent to Malibu to seed the new Payson collection.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13314/rec/719",
          title: "The Malibu Times",
          date: "6/30/72",
          publisher: "Pepperdine University Archives",
          page: "6",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/3590/rec/94",
          title: "The Graphic",
          date: "3/9/73",
          publisher: "Pepperdine University Archives",
          page: "8",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/100/rec/7",
          title: "Inner View",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["donors", "library"],
    seeAlso: {
      people: ["M. Norvel Young"],
      events: ["721006B", "721013A"],
    },
  },
  {
    id: "720630B",
    title: "Senior named Miss Carson",
    date: new Date("6/30/1972 13:00:00"),
    location: "Carson",
    description: {
      text: "Pepperdine senior Debbie Bronder was named winner of the 1972-1973 Miss Carson beauty pageant. The blonde would serve as an official representative of the City of Carson at various dedications and ground-breaking ceremonies, as well as at the LA County fair.<1>\nTwo years earlier, Carson had been a yell leader (a kind of cheerleader) for the Waves.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13317/rec/719",
          title: "The Malibu Times",
          date: "6/30/72",
          publisher: "Pepperdine University Archives",
          page: "9",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/4255/rec/1",
          title: "The Graphic",
          date: "10/22/70",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cheerleading", "student life"],
    seeAlso: {
      people: ["Debbie Bronder"],
      events: ["720428A"],
    },
  },
  {
    id: "720701A",
    title: "Raleigh Neal Runnels dies at 17",
    date: new Date("7/1/1972"),
    location: "Pacific Palisades",
    description: {
      text: "Raleigh Neal Runnels was the son of Pepperdine vice chancellor Charles Runnels. For two years, he planned to enter the freshman class at the opening of Pepperdine's Malibu campus in September 1972.<1> Sadly, after a two-year fight with melanoma,<2> Raleigh died at the age of 17 just two months before the campus would open (and two weeks after his high school graduation).<3>\nRaleigh's funeral was held at the Inglewood Church of Christ and conducted by Pepperdine chancellor Norvel Young.<3> Three days after the funeral, Blanche Seaver, who had attended services at the Inglewood church with Raleigh, committed $650,000 to fund Pepperdine's swimming pool, on the condition that it be named the Raleigh Runnels Memorial Pool.<1> Further donations totaling $300,000 came from Morris Pendleton and others.\nIn the 1984 Summer Olympics, the water polo competitions were held in the pool named for Runnels.",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "256",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "303",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13967/rec/722",
          title: "The Malibu Times",
          date: "7/21/72",
          publisher: "Pepperdine University Archives",
          page: "12",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["administration", "athletics", "construction", "student life"],
    seeAlso: {
      people: ["Raleigh Neal Runnels", "Charles Runnels", "M. Norvel Young", "Blanche E. Seaver", "Morris Pendleton"],
      events: [],
    },
  },
  {
    id: "720714A",
    title: "Contest for new business school logo",
    date: new Date("7/14/1972"),
    location: "LA campus",
    description: {
      text: "Pepperdine's School of Business (soon to change its name to the School of Business and Management) held a contest to design its new logo. The deadline for submissions was July 14.<1>\nThe school was founded in 1968, when the Board of Trustees approved a plan to separate it from the business department, which was already offering an MBA. The decision to have a free-standing business school was motivated by accreditation requirements.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6261/rec/78",
          title: "The Graphic",
          date: "6/22/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "209-211",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["graduate schools"],
    seeAlso: {
      people: [],
      events: [],
    },
  },
  {
    id: "720720A",
    title: "LA expects 200 residents for fall term",
    date: new Date("7/20/1972"),
    location: "LA campus",
    description: {
      text: "With less than two months to go, only 60 students had requested a room on the LA campus for the fall term (41 women and 19 men). Administrators expected more students to register in the coming week, and efforts were being made to improve the dorms in hope of luring more residents with amenities like color TV and new drapes.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9447/rec/79",
          title: "The Graphic",
          date: "7/20/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["housing"],
    seeAlso: {
      people: [],
      events: ["720217C", "720518B"],
      stories: ["S72LHSG"],
    },
  },
  {
    id: "720720B",
    title: "Malibu expecting 800 students",
    date: new Date("7/20/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "Just months before opening, Malibu anticipated 800 students for the 1972 fall term. Over half that number would be freshmen.<1>\nWith less than 50 days to go, the campus was still a construction site: the science building was nearly finished and the library was just weeks away from completion, but the dorms were still a work in progress. Malibu provost Jerry Hudson quipped to |The Graphic|, \"We hope the beds arrive before the students.\"<1>\nIn fact, fall enrollment at Malibu would top 850, with 475 freshmen.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9449/rec/79",
          title: "The Graphic",
          date: "7/20/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7721/rec/80",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "1"
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: ["720602A", "720731A", "720906D"],
    },
  },
  {
    id: "720720C",
    title: "Last LA issue of the Graphic",
    date: new Date("7/20/1972 14:00:00"),
    location: "LA campus",
    description: {
      text: "The July 20 issue of |The Graphic| (Vol. 36, No. 35), was the final issue to be published from the LA campus. In the fall, |The Graphic| would move to the new Malibu campus, in a new five-column format. The LA campus would be served by a new publication called |The Inner View|, which would be in the tabloid format.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9449/rec/79",
          title: "The Graphic",
          date: "7/20/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["newspapers", "student life"],
    seeAlso: {
      people: [],
      events: ["720728A", "721006A"],
      stories: ["S72NEWS"],
    },
  },
  {
    id: "720724A",
    title: "Tapia pipeline construction begins",
    date: new Date("7/24/1972"),
    location: "Malibu",
    description: {
      text: "On July 24, the Las Virgenes Municipal Water District approved Pepperdine's intent to construct twin pipelines to carry sewage to (and reclaimed water from) the Tapia water reclamation facility near Piuma Road.<1> (Formal approval came on August 7.)<2> Construction of the pipelines began in mid July,<1> and was carried out by Kirst Construction Company.<3> For two months, construction workers cut a ditch alongside Malibu Canyon Road to lay five miles of parallel six-inch pipes.<3> The work had to be finished by September 6, when the Malibu campus was scheduled to open to students.\nReclaimed water piped back to campus was used to irrigate landscaping, and excess was held in a pond in the meadow today called Alumni Park.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/1234/rec/1",
          title: "Inner View",
          date: "7/28/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13620/rec/725",
          title: "The Malibu Times",
          date: "8/11/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "297",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "sewer"],
    seeAlso: {
      people: [],
      events: ["720316A", "720504A", "720507A", "720622A", "720728A", "720815A", "720816A", "721119A", "721129A"],
      stories: ["S72SEWR"],
    },
  },
  {
    id: "720728A",
    title: "LA campus gets new student paper",
    date: new Date("7/28/1972"),
    location: "LA campus",
    description: {
      text: "With the departure of |The Graphic| to the Malibu campus, students on the LA campus began a new publication called |Inner View|, which declared its primary focus to be \"news that affects the L.A. campus community.\" The debut edition featured stories on the Malibu sewer saga, the construction of the Firestone Fieldhouse, and PE offerings at the Malibu campus, as well as a broken sprinkler on the LA campus that watered more cars than lawns.<1>\nThe paper was published for four years before folding with the termination of the journalism program on the LA campus in 1976, when only a handful of residential students remained at Vermont and 79th.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/1234/rec/1",
          title: "Inner View",
          date: "7/28/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "188",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["newspapers", "student life"],
    seeAlso: {
      people: [],
      events: ["720720C", "720724A", "721006A"],
      stories: ["S72NEWS"],
    },
  },
  {
    id: "720731A",
    title: "First Malibu dorm due to be finished",
    date: new Date("7/31/1972"),
    location: "Malibu",
    description: {
      text: "Malibu provost Jerry Hudson told |The Graphic| that ten dormitories would be ready for the opening of the Malibu campus in September. The first was due to be completed July 31, with an additional one following every three days thereafter. Two more dorms had been ordered but would not be completed in time for the beginning of the term. Students were told to expect bunking three to a room (but no more than ten to a four-room suite) while construction continued.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9450/rec/79",
          title: "The Graphic",
          date: "7/20/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "housing"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: ["720217C", "720602A", "720906A"],
      stories: ["S72MHSG"],
    },
  },
  {
    id: "720731B",
    title: "10th anniversary of Pepperdine's death",
    date: new Date("7/31/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "The tenth anniversary of the death of university founder George Pepperdine passed without much fanfare in 1972. His death (of an aortic aneurysm) in 1962 was followed by a funeral featuring president Norvel Young, among others.\nPepperdine spent the last several years of his life living modestly after practically all of the money he hadn't donated to the school was lost in imprudent investments. He was survived by his (second) wife, Helen, who continued to serve on Pepperdine's Board of Trustees for many years.<1>",
      sources: [
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "15",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["donors"],
    seeAlso: {
      people: ["George Pepperdine", "Helen Pepperdine", "M. Norvel Young"],
      events: ["721016B"],
    },
  },
  {
    id: "720811A",
    title: "Lemley named associate dean of student life",
    date: new Date("8/11/1972"),
    location: "Malibu",
    description: {
      text: "|The Malibu Times| reported that Steven Lemley would serve as associate dean of student life for the new Malibu campus when it opened in September.<1> Lemley, the son-in-law of Pepperdine chancellor Norvel Young, was a recent arrival from Ohio State, where he did his PhD in communication.\nLemley served under dean of student life Bob Thomas, who had served as dean of admissions at the LA campus.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13629/rec/725",
          title: "The Malibu Times",
          date: "8/11/72",
          publisher: "Pepperdine University Archives",
          page: "10",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["administration"],
    seeAlso: {
      people: ["Steven Lemley", "M. Norvel Young", "Bob Thomas"],
      events: [],
    },
  },
  {
    id: "720826A",
    title: "Security cameras proposed for LA campus",
    date: new Date("8/26/1972"),
    location: "LA campus",
    description: {
      text: "The security chief at Pepperdine's LA campus proposed a system of security cameras be installed to boost campus security. \"We don't want a situation where the faculty and students do not feel totally safe being on campus,\" he explained. The cameras were in addition to a second security booth being added at the south entrance to campus.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/913/rec/2",
          title: "Inner View",
          date: "8/72",
          publisher: "Pepperdine University Archives",
          page: "8",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["security"],
    seeAlso: {
      people: [],
      events: ["720406A", "720501A"],
      stories: ["S72SECU"]
    },
  },
  {
    id: "720904A",
    title: "Certificate of occupancy granted",
    date: new Date("9/4/1972"),
    location: "Malibu",
    description: {
      text: "Following a three-hour inspection by officials from the LA County Department of Building and Safety and the county fire department, Pepperdine's new Malibu campus (as represented by president William Banowsky and provost Jerry Hudson) received its certificate of occupancy.<1> It came right on time: students were due to move onto campus just two days later.\nMany buildings were still under construction, including Stauffer Chapel and Firestone Fieldhouse, but the core academic buildings of central campus were ready, as were ten dorms and the cafeteria.",
      sources: [
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "298",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["William S. Banowsky", "Jerry Hudson"],
      events: ["720906A"],
    },
  },
  {
    id: "720905A",
    title: "Main parking lot paved",
    date: new Date("9/5/1972"),
    location: "Malibu",
    description: {
      text: "The main parking lot on Pepperdine's new Malibu campus was paved the day before students were set to arrive. |The Graphic| reported in its first issue from Malibu that the campus's construction was still underway right up to the deadline. Malibu provost Jerry Hudson said, \"I had people telling me as late as August that there was no way it could be done.\"<1>\nThe main lot was larger in 1972 than it is today, as Smothers Theatre and the rest of the fine arts complex have eaten into the space over the years.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7717/rec/80",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: {
      path: "/assets/ParkingLot.png",
      caption: "The main parking lot and central campus, c. August 1972 (not, as the Archives say, Sept. 22).",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/10026/rec/472",
        title: "Pepperdine campus under construction",
        date: "9/22/72",
        publisher: "Margaret Martin Brock Collection",
        page: "",
      },
    },
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: ["720906A"],
      stories: ["S72OPEN"],
    },
  },
  {
    id: "720906A",
    title: "Students move onto Malibu campus",
    date: new Date("9/6/1972"),
    location: "Malibu",
    description: {
      text: "The dream of Pepperdine Malibu became a reality on September 6, 1972, the day students first descended on the 490-acre campus.<1> The fall enrollment of about 850 included 475 freshmen, the largest class of first-year students in the school's history to that point. There was only room in the newly built dorms for 500 students.<2>\nThe campus they arrived to was only barely ready in time: just days earlier the campus had been connected to sewer service, and the gas wasn't turned on until after students began moving in.<3> The main parking lot was paved the day before move-in, and lighting in the library was inadequate for at least the first month.<2>\nThe campus effectively remained a construction zone for some time. Stauffer Chapel, the Phillips Theme Tower, and Firestone Fieldhouse were all under construction (and would remain so for quite a while). More dorms were being put up as quickly as possible to accommodate the larger-than-expected incoming class.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll13/id/1731/rec/18",
          title: "Pepperdine University Student Handbook, 1972-1973",
          date: "1972",
          publisher: "Pepperdine University Archives Student Life Collection",
          page: "10",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7717/rec/80",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "315",
        },
      ],
    },
    photo: {
      path: "/assets/MoveIn.png",
      caption: "A student moving into the new dorms on the Malibu campus, Sept. 6, 1972.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/1059/rec/7",
        title: "Student moving into new Malibu dormitories, 1972",
        date: "Sept. 1972",
        publisher: "Pepperdine University Archives Photograph Collection",
        page: "",
      },
    },
    event: true,
    tags: ["student life"],
    seeAlso: {
      people: [],
      events: ["720905A", "720906C", "720906F", "720906G", "720912A"],
      stories: ["S72OPEN"],
    },
  },
  {
    id: "720906C",
    title: "Tree planting ceremony",
    date: new Date("9/6/1972 14:00:00"),
    location: "Malibu",
    description: {
      text: "Leo Hirsh, chairman of the Trees for Pepperdine Malibu effort, hosted a tree planting ceremony on the Malibu campus the day it opened. The ceremony featured a tree transplanted from the LA campus, signifying the unity of the university.<1> Among the donors present at the event were two women representing the past and the future of the institution: Helen Pepperdine (widow of founder George Pepperdine) and Blanche Seaver, whose donations to the Malibu project would come to be honored in the name of Seaver College.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13749/rec/729",
          title: "The Malibu Times",
          date: "9/8/72",
          publisher: "Pepperdine University Archives",
          page: "1, 2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/240/rec/1",
          title: "Inner View",
          date: "9/15/1972",
          publisher: "Pepperdine University Archives",
          page: "5",
        },
      ],
    },
    photo: {
      path: "/assets/TreeCeremony.png",
      caption: "Left to right: Helen Pepperdine, Leo Hirsh, Blanche Seaver, and Norvel Young, at the tree planting ceremony the day the new campus opened.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/p271401coll15/id/10026/rec/472",
        title: "Tree Planting Ceremony",
        date: "9/6/72",
        publisher: "Pepperdine University Archives Photograph Collection",
        page: "",
      },
    },
    event: true,
    tags: ["construction", "events"],
    seeAlso: {
      people: ["Leo Hirsh", "Helen Pepperdine", "Blanche E. Seaver", "M. Norvel Young"],
      events: ["720616B", "721103A", "721106A"],
      stories: ["S72OPEN"],
    },
  },
  {
    id: "720906F",
    title: "First dinner in the caf is cold sandwiches",
    date: new Date("9/6/1972 17:00:00"),
    location: "Malibu",
    description: {
      text: "The brand-new Tyler Dining Room opened for its first meal on September 6, 1972, the day students arrived to Malibu. With 1,000 mouths to feed, there were just a few obstacles to overcome: like the fact that no appliances had been delivered except a meat slicer and a small refrigerator, or that the loading dock couldn't take deliveries, or that the kitchen floor had just been painted and could only be walked on in socks.<1>\nDespite these challenges, the team put together a meal of sandwiches, fruit, and coffee, served on paper plates. |The Graphic| quipped of the food service manager and his assistant, \"Be thankful that these two met the challanges [sic] of their task [...] It's a long walk down the mountain to Colonel Sanders.\"<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/3178/rec/81",
          title: "The Graphic",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cafeteria"],
    seeAlso: {
      people: [],
      events: ["720929A"],
      stories: ["S72OPEN"],
    },
  },
  {
    id: "720906G",
    title: "Malibu becomes college town",
    date: new Date("9/6/1972 18:00:00"),
    location: "Malibu",
    description: {
      text: "With the opening of Pepperdine's new campus, Malibu became a college town. |The Malibu Times| welcomed Pepperdine warmly, declaring \"the beginning of a new era in Malibu\" and calling the school \"a great asset to Malibu.\"<1> Not everyone was so friendly, though, with some residents opposing the construction of the theme tower, and others worried about an influx of students.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13749/rec/729",
          title: "The Malibu Times",
          date: "9/8/72",
          publisher: "Pepperdine University Archives",
          page: "1, 2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["Malibu"],
    seeAlso: {
      people: [],
      events: ["720531A"],
      stories: ["S72OPEN"],
    },
  },
  {
    id: "720910A",
    title: "Church of Christ moves to Elkins",
    date: new Date("9/10/1972"),
    location: "Malibu",
    description: {
      text: `The Church of Christ of Malibu, which was founded by a group of Pepperdine faculty and staff families before the campus opened, had been meeting in the Civic Center.<1> The first Sunday after campus was opened to students, the church began holding services in the brand-new Elkins Auditorium, the main lecture hall on the new campus.<2> The preaching minister at the time was Tony Ash, the head of the religion department.<2> The church is the ancestor of today's University Church of Christ, which still meets on campus.\nThe church was established when a handful of families began meeting in Malibu in April 1970. Pioneering families included those of Norvel Young, William Banowsky, Jerry Hudson, and Walter Glass.<2>`,
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13545/rec/731",
          title: "The Malibu Times",
          date: "9/22/72",
          publisher: "Pepperdine University Archives",
          page: "4, 6",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "392",
        }
      ],
    },
    photo: null,
    event: true,
    tags: ["religion", "student life"],
    seeAlso: {
      people: ["Tony Ash", "M. Norvel Young", "William S. Banowsky", "Jerry Hudson", "Walter Glass"],
      events: ["720906A"],
    },
  },
  {
    id: "720912A",
    title: "First day of classes",
    date: new Date("9/12/1972"),
    location: "Malibu",
    description: {
      text: "The fall term began on the Malibu campus,<1> featuring a new interdisciplinary curriculum that had been designed for what would become Seaver College. The seventeen departments from the LA campus were lumped into six broad divisions: humanities, social science, natural science, communication, religion, and fine arts.<2> The interdisciplinary nature of the curriculum was reinforced by the campus's master plan, as designed by William Pereira, with closely clustered buildings, a common laboratory, and small classrooms with only one lecture hall.<3>\nAmong the faculty responsible for planning the new curriculum were Jerry Hudson, James Smythe, and Tony Ash.<4>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll13/id/1731/rec/18",
          title: "Pepperdine University Student Handbook, 1972-1973",
          date: "1972",
          publisher: "Pepperdine University Archives Student Life Collection",
          page: "10",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "311",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "310",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "266",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["academics", "student life"],
    seeAlso: {
      people: ["William Pereira", "Jerry Hudson", "James Smythe", "Tony Ash"],
      events: ["720906A"],
      stories: ["S72OPEN"]
    },
  },
  {
    id: "720915A",
    title: "School of Law granted ABA accreditation",
    date: new Date("9/15/1972"),
    location: "Santa Ana",
    description: {
      text: "At its August meeting, the American Bar Association (ABA) granted Pepperdine's fledgling School of Law provisional approval, making it the only ABA-approved law school in Orange County. ABA approval meant that graduates of the school would be permitted to take the bar exam in any state. Previously, the school was only accredited by the California State Bar, meaning graduates were eligible to take the bar only in California. The same week, dean Ronald Phillips announced a new record enrollment of 389 students.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/238/rec/3",
          title: "Inner View",
          date: "9/15/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["graduate schools"],
    seeAlso: {
      people: ["Ronald Phillips"],
      events: ["720323A"],
    },
  },
  {
    id: "720929A",
    title: "LA students say food is better in Malibu",
    date: new Date("9/29/1972"),
    location: "LA campus",
    description: {
      text: "The student senate on the LA campus voiced concerns that its food service was inferior to the one offered at Malibu. Professional Food Service Management administered the university's food service at both campuses. Students on the LA campus (where there were 108 residential students) complained that there was greater variety on the menu at Malibu, where there were 604.<1>\nThe manager of food service on the LA campus explained that offering a diverse menu was made difficult by the lack of customers early in the term: \"We fed two people the first day, and six people the second.\"<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/1364/rec/5",
          title: "Inner View",
          date: "9/29/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cafeteria", "student life"],
    seeAlso: {
      people: [],
      events: ["720126A", "720209A", "720906F"],
      stories: ["S72WHIN"],
    },
  },
  {
    id: "720929B",
    title: "$1M donation from Canfield estate",
    date: new Date("9/29/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "The Canfield Foundation, named for oilman Charles A. Canfield, announced a grant of one million dollars to be used for scholarships at Pepperdine University. The Foundation was established by Canfield before his death in 1913, and much of the money was earmarked for the education of young people.<1>\nCanfield had been a business partner of the oil tycoon Edward Doheny, who at the height of his wealth was one of the richest men in America, and who was a close friend of Frank Seaver, the husband of Blanche Seaver.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/12889/rec/732",
          title: "The Malibu Times",
          date: "9/29/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "117",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["donors"],
    seeAlso: {
      people: ["Charles Canfield", "Blanche E. Seaver"],
      events: [],
      stories: ["S72DON8"]
    },
  },
  {
    id: "721002A",
    title: "LA campus bookstore burgled",
    date: new Date("10/2/1972"),
    location: "LA campus",
    description: {
      text: "The bookstore on Pepperdine's LA campus was broken into at 10:45pm. The suspects made away with $1600 in merchandise, including two IBM electric typewriters, an adding machine, and two cassette tape recorders. The burglars were spotted making their getaway, and security guards chased them behind Marilyn Hall (the girls' dorm), where they dumped the typewriters and adding machine to lighten their load.<1>\nThe incident was part of a string of crimes on the LA campus in 1972 causing a tightening of security protocols.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/1228/rec/6",
          title: "Inner View",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "5",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["security"],
    seeAlso: {
      people: [],
      events: ["720512A"],
      stories: ["S72SECU"]
    },
  },
  {
    id: "721006A",
    title: "First Graphic issue from Malibu",
    date: new Date("10/6/1972"),
    location: "Malibu",
    description: {
      text: "Pepperdine's student newspaper opened its 36th academic year from its new digs in Malibu. Starting over its numbering at Vol. 1, No. 1, the award-winning publication adopted a new five-column format. The lead story was the opening of the Malibu campus the month before.\nOther stories included donations to the school from Fritz Huntsinger, the Canfield Foundation, and a group of LA art lovers. Also covered was the formation of the Associated Student Board, the new student government body designed by dean of student life Bob Thomas, with its founding chairman, Randy Lowry. Among the editorials was one praising the role Malibu provost Jerry Hudson played in ensuring the campus was ready to open.<1>\nStudents seemed pleased with the new campus, even though it remained an active construction zone, with work continuing on the fieldhouse and the chapel. One persistent complaint in the first month was about insufficient lighting in Payson Library. |The Graphic| quoted provost Jerry Hudson saying, \"We realize that at this point the situation is barely adequate,\" and promising to put lights on all study carrels.<1>\nWith |The Graphic| moving to Malibu, the LA campus launched a student newspaper of its own, |The Inner View|.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7721/rec/80",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "1-4",
        },
      ],
    },
    photo: {
      path: "/assets/Graphic.png",
      caption: "The front page of The Graphic's first issue from the Malibu campus in October 1972.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7717/rec/80",
        title: "The Graphic",
        date: "10/6/72",
        publisher: "Pepperdine University Archives",
        page: "1",
      },
    },
    event: true,
    tags: ["library", "newspapers", "student life"],
    seeAlso: {
      people: ["Fritz Huntsinger", "Bob Thomas", "Randy Lowry", "Jerry Hudson"],
      events: ["720720C", "720728A", "720929B", "721006B", "721006E"],
      stories: ["S72NEWS"],
    },
  },
  {
    id: "721006B",
    title: "Huntsinger donates giant eagle sculpture",
    date: new Date("10/6/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "Fritz Huntsinger donated a lot to Pepperdine over the years (lending his name to the Huntsinger Academic Complex, which consists of Payson Library and Pendleton Learning Center), but one of his more interesting gifts was an 800-pound teak sculpture of an eagle, donated in the fall of 1972.\nThe piece has a 79-inch wingspan and stands twelve feet high (including its podium).<1> Huntsinger commissioned the work on a trip to Taiwan,<2> and it took eight months to complete.<1> At the dedication of the Huntsinger Academic Complex, the eagle caught everyone's attention,<3> and Huntsinger explained that the eagle represented \"the academic freedom as taught at Pepperdine.\"<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7720/rec/80",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13895/rec/143",
          title: "The Malibu Times",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/3181/rec/81",
          title: "The Graphic",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["arts", "donors", "library"],
    seeAlso: {
      people: ["Fritz Huntsinger"],
      events: ["721006E", "721103A", "721117A"],
      stories: ["S72DONO"],
    },
  },
  {
    id: "721006C",
    title: "LA students complain they get less for tuition",
    date: new Date("10/6/1972 14:00:00"),
    location: "LA campus",
    description: {
      text: "LA students couldn't help but feel that the departure of the liberal arts program to the new Malibu campus had resulted in a two-tiered system, with preference being given to the new campus. Their chief concern was that their tuition dollars were going to their peers across the bay.<1>\n|Inner View| quoted the president of the LA student body complaining, \"I feel that it is grossly unfair for L.A. tuition to be equal to Malibu, when the facilities are not equal.\" In response, executive vice president Howard White explained that tuition went to things like building maintenance and that costs were actually higher on the LA campus, where the buildings were older.<1>\nThe vice president for finance explained that tuition paid by students at the LA campus did not support the Malibu campus.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/1226/rec/6",
          title: "Inner View",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["student life"],
    seeAlso: {
      people: ["Howard A. White"],
      events: ["720929A","721013A"],
      stories: ["S72WHIN"],
    },
  },
  {
    id: "721006E",
    title: "\"Art lovers\" donate forgeries to Malibu",
    date: new Date("10/6/1972 16:00:00"),
    location: "Malibu",
    description: {
      text: "A group of 17 art enthusiasts from Los Angeles donated six paintings to Pepperdine upon the opening of its Malibu campus.<1> The works, which included a piece attributed to Jacques-Louis David, were valued at more than $250,000 by appraisers.\n|The Graphic| quoted Pepperdine president William Banowsky saying, \"They heard about our new campus here and decided we needed some works of the Old Masters.\"<2>\nBy the time Pepperdine came to collect the paintings, however, two of them were missing and the donors' attorney Brent Carruth claimed one of them had been stolen from his office, where they were being kept. It later emerged that five of the six paintings were reproductions being passed off as originals, \"valuable simply as decorative art to be used in a hotel, home or a religious institution.\"<3> The director of the Los Angeles County Museum of Art (LACMA), Kenneth Donahue, personally inspected the paintings and proved them to be fakes. It became clear that the donation was tax fraud, and at least one of the donors lost a case  in US Tax Court relating to the donation.<3>\nIn two unrelated developments, Brent Carruth, the attorney involved in arranging the donation, was disbarred by the California Supreme Court in 1996,<4> and was sentenced to jail in 2011 for grand theft.<5>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/12889/rec/732",
          title: "The Malibu Times",
          date: "9/29/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7720/rec/80",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
        {
          url: "https://www.leagle.com/decision/1977143036mitcm139411084",
          title: "Dennis M. Vander Hook and Judy E. Vander Hook v. Commissioner",
          date: "9/29/77",
          publisher: "36 T.C.M. 1394",
          page: "",
        },
        {
          url: "https://www.anylaw.com/case/in-re-a-brent-carruth-on-discipline/california-supreme-court/12-23-1996/4qKCR2YBTlTomsSBrHwQ",
          title: "In re: A. Brent Carruth on Discipline",
          date: "12/22/96",
          publisher: "anylaw",
          page: "",
        },
        {
          url: "https://losangeles.cbslocal.com/2011/11/17/wedding-photographer-gets-jail-time-for-not-delivering-photos-albums/",
          title: "Wedding Photographer Gets Jail Time For Not Delivering Photos, Albums",
          date: "11/17/2011",
          publisher: "CBSLA",
          page: "",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["arts", "donors"],
    seeAlso: {
      people: ["William S. Banowsky"],
      events: ["721006B"],
      stories: ["S72DONO"],
    },
  },
  {
    id: "721013A",
    title: "LA students complain about library books",
    date: new Date("10/13/1972"),
    location: "LA campus",
    description: {
      text: "Students on the LA campus complained that too many books had been taken from the library to support the opening of Payson Library in Malibu. About a quarter of LA's 100,000 volumes were transferred to Malibu, which then acquired a major donation of hundreds of thousands of volumes. The decision of which books to move was made by faculty members.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/100/rec/7",
          title: "Inner View",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["library", "student life"],
    seeAlso: {
      people: [],
      events: ["720630A", "720929A", "721006C"],
      stories: ["S72WHIN"],
    },
  },
  {
    id: "721013B",
    title: "LA puts on A Raisin in the Sun",
    date: new Date("10/13/1972 13:00:00"),
    location: "LA campus",
    description: {
      text: "Students on the LA campus put on |A Raisin in the Sun|, a 1959 play by Lorraine Hansberry about a Black family in south Chicago.<1> The play was sponsored by Harambee (formerly known as the Black Student Union), with funds from the student senate.<2> Student tickets cost $1.<1>\nWhen the play premiered on Broadway in 1959, it starred Bahamian actor Sidney Poitier in the lead role of Walter Lee Younger. In 1976, Poitier's daughter Sherri attended Pepperdine.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/107/rec/7",
          title: "Inner View",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "10",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/1226/rec/2",
          title: "Inner View",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://books.google.com/books?id=gMADAAAAMBAJ&lpg=PA44&ots=U7kgFOFNJB&pg=PA44",
          title: "Jet",
          date: "2/12/76",
          publisher: "Google Books",
          page: "44",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["arts", "student life"],
    seeAlso: {
      people: [],
      events: ["720224A"],
    },
  },
  {
    id: "721013C",
    title: "Freeze on Malibu construction",
    date: new Date("10/13/1972 14:00:00"),
    location: "Malibu",
    description: {
      text: "In the fall of 1972, Pepperdine believed it was under a building freeze imposed by LA County, halting development of phase II buildings, including what would be the Thornton Administrative Center (TAC) and the fine arts complex including Smothers Theatre. Malibu provost Jerry Hudson told |Inner View| the freeze would block construction indefinitely,<1> and |The Graphic| reported completion of both projects would be delayed well into 1973.<2>\n|The Malibu Times| reported that environmental organizations had persuaded the County Board of Supervisors to return all building permits to Regional Planning for review.<3> None of these sources give much detail about the nature of the order.\nPresident William Banowsky recalls in his memoir that the source of the freeze was a September 18 order from the California Supreme Court prohibiting developers from beginning new projects along the California coast in anticipation of the November passage of a statewide referendum that would create the California Coastal Commission.<4> Banowsky, however, cites (a non-existent issue of) |The Malibu Times|, and the only discussion of the freeze in the |Times| makes no mention of a court ruling or the Coastal Commission vote.\nWhat is certainly true is that the creation by referendum of the California Coastal Commission in November 1972 forever changed the special relationship Pepperdine had developed with the LA County Board of Supervisors that had permitted all construction efforts on the Malibu campus. The Coastal Commission put an end to the local control of coastal zones, requiring development to be approved by the state body or one of its regional commissions.<5> (Banowsky records the date of the vote as November 6, a Monday,<4> but it was actually Tuesday the 7th).\nConstruction of the administration building and the fine arts complex would not be completed for years. Phase II essentially began with the ground breaking for the fine arts complex in 1977.<6> The university broke ground for the TAC in 1984, having finally received Coastal Commission approval of a building that had been part of the campus's master plan since 1972. It opened in 1986.<7>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/763/rec/8",
          title: "Inner View",
          date: "10/20/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/3181/rec/81",
          title: "The Graphic",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13542/rec/731",
          title: "The Malibu Times",
          date: "9/22/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "301",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "296",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "302",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "457",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: ["Jerry Hudson", "William S. Banowsky"],
      events: ["721107B"],
    },
  },
  {
    id: "721016A",
    title: "Basketball team starts season on new court",
    date: new Date("10/16/1972"),
    location: "Culver City",
    description: {
      text: "Pepperdine's men's basketball team was slated to begin practicing for its season on a new court (the team's fifth in five years). Their new home would be the Veteran's Memorial Auditorium in Culver City. In the 1971-1972 season, they had played their home games at Samohi (i.e., Santa Monica High School).<1> They had hoped to play the 1972-1973 season at the new Firestone Fieldhouse, but it was still under construction (it wouldn't be completed until October 1973).\nThe Waves would depend heavily on their star William \"Bird\" Averitt who had scored nearly 29 points per game the year before, his sophomore season.<1> Support would come from a pair of freshmen who would be allowed to play under a new NCAA rule that ended the ban on freshmen in varsity competition.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/105/rec/7",
          title: "Inner View",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "8",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9881/rec/61",
          title: "The Graphic",
          date: "1/13/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["William \"Bird\" Averitt", "Gary Colson"],
      events: ["720108B", "721125A"],
    },
  },
  {
    id: "721016B",
    title: "36th annual Founder's Day",
    date: new Date("10/16/72 13:00:00"),
    location: "LA campus",
    description: {
      text: "The annual convocation to honor George Pepperdine was held at the Los Angeles campus. Professor Tony Ash, chairman of Malibu's religion department, gave the main speech, saying, \"I am convinced that if we understand the word Christian in the best sense of the term, that there is a complete compatibility between being Christian and having an open search for truth with integrity.\"<1>\nAt a parallel gathering on the Malibu campus, Professor James Smythe reminisced about his friend George Pepperdine, who had died ten years earlier. Smythe quoted Pepperdine as saying, \"What I kept myself, I lost; what I gave away has been kept; I only regret I had not given it all away.\"<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/3030/rec/82",
          title: "The Graphic",
          date: "10/20/72",
          publisher: "Pepperdine University Archives",
          page: "1-2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["events"],
    seeAlso: {
      people: ["George Pepperdine", "Tony Ash", "James Smythe"],
      events: ["720731B"],
    },
  },
  {
    id: "721020A",
    title: "LA students unimpressive academically",
    date: new Date("10/20/1972"),
    location: "LA campus",
    description: {
      text: "With the departure of the liberal arts program to the Malibu campus, the students who remained on the LA campus were less impressive academically. In a letter to |The Inner View|, one student challenged the notion that the campus was competitive academically, pointing out that GRE scores from 1969-1970 put Pepperdine grads around the 27th percentile nationally.<1>\nThese scores square well with data from Pepperdine historian David Baird, who reports that SAT scores for freshman beginning at the LA campus in 1973 averaged 780, about 150 points below freshmen at Malibu, who were near the national average.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/765/rec/8",
          title: "Inner View",
          date: "10/20/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "187",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["academics"],
    seeAlso: {
      people: [],
      events: [],
    },
  },
  {
    id: "721103A",
    title: "56-year-old coral tree donated",
    date: new Date("11/3/1972"),
    location: "Malibu",
    description: {
      text: "William Palmer of Hollywood donated a 22-foot-tall tree to Pepperdine's Malibu campus. The coral tree had been marked for removal by developers building an apartment complex in Hollywood, but Palmer heard about the Trees for Pepperdine Malibu effort and offered it to the new campus.<1>\nMoving the twelve-ton giant proved tricky.<2> The first plan was to put it on a truck and crawl through the city late at night, but the State Division of Highways deemed the disruption to traffic unacceptable at any hour. Alternative plans included helicopters and barges, but they all proved too expensive or just impractical.<1>\nUltimately, with the help of governor Ronald Reagan (a friend of president William Banowsky),<3> permission came to move it by truck just two hours before the deadline.<1> The journey began at 11pm and ended at 7am the next day. The truck had to stop at every power line along the way to ensure it would fit under. The closest call was at a pedestrian bridge on PCH, where the tree just scraped through. The parade, including several California Highway Patrolmen and two State Department of Highways officials, arrived to the Malibu campus at 7am, where the tree was unloaded near the Seaver Drive entrance.<1> It guarded the entrance for at least two decades.<3>\nThe tree was of the species |Erythrina crista-galli|, a cousin to the coral trees (|Erythrina caffra|) now familiar on campus. Though the species is common in Argentina, where it is the national tree, Palmer's was thought to be one of only three specimens in Los Angeles.<4>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/527/rec/83",
          title: "The Graphic",
          date: "11/3/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7448/rec/84",
          title: "The Graphic",
          date: "11/10/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "303",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/p15730coll31/id/597/rec/11",
          title: "Inner View",
          date: "11/10/72",
          publisher: "Pepperdine University Archives",
          page: "8",
        },
      ],
    },
    photo: {
      path: "/assets/Erythrina.png",
      caption: "The coral tree donated to Pepperdine by William Palmer in November 1972.",
      source: {
        url: "https://cdm15730.contentdm.oclc.org/digital/collection/p271401coll15/id/1851",
        title: "Pepperdine University sign at Malibu Canyou Road entrance, 1973",
        date: "8/3/73",
        publisher: "Pepperdine University Archives",
        page: "1",
      },
    },
    event: true,
    tags: ["donors"],
    seeAlso: {
      people: ["William S. Banowsky"],
      events: ["720616B", "720906C", "721106A"],
      stories: ["S72DONO", "S72TREE"],
    },
  },
  {
    id: "721106A",
    title: "Ecology Day: grass sown on barren hills",
    date: new Date("11/6/1972"),
    location: "Malibu",
    description: {
      text: "In an effort to prevent erosion, Pepperdine students were sent out onto the hills surrounding the Malibu campus to sow grass seed. The campus's construction had stripped off the native chaparral, leaving the hills unstable before the coming rainy season.<1> The Inter-Club Council organized an Ecology Day, during which members of the community wandered the hills with pillowcases of barley and rye donated by the Malibu Feed Bin,<1> sowing the meadow that would become Alumni Park and Pepperdine's now-familiar lawn.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/527/rec/83",
          title: "The Graphic",
          date: "11/3/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13838/rec/1",
          title: "The Malibu Times",
          date: "11/17/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: {
      path: "/assets/Sower.png",
      caption: "A student sows grass on a barren campus hillside.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/527/rec/83",
        title: "The Graphic",
        date: "11/3/72",
        publisher: "Pepperdine University Archives",
        page: "1",
      },
    },
    event: true,
    tags: ["construction"],
    seeAlso: {
      people: [],
      events: ["720616B", "720906C"],
    },
  },
  {
    id: "721107A",
    title: "Richard Nixon re-elected president",
    date: new Date("11/7/1972"),
    location: "Malibu",
    description: {
      text: "|The Graphic| reported on the re-election of President Richard Nixon. The Republican incumbent won the electoral college in a historic 521-17 landslide over Democratic challenger George McGovern, who won only Massachusetts and DC.<1> Pepperdine president William Banowsky had been a major supporter of Nixon's re-election in Southern California.\nNearly two years later, Nixon would resign in disgrace following investigations into his campaign's foul play at the Watergate complex.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7452/rec/84",
          title: "The Graphic",
          date: "11/10/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["politics"],
    seeAlso: {
      people: ["William S. Banowsky"],
      events: ["720217B"],
    },
  },
  {
    id: "721107B",
    title: "Coastal Commission created",
    date: new Date("11/07/1972 13:00:00"),
    location: "Sacramento",
    description: {
      text: "California voters approved proposition 20, a ballot initiative creating the California Coastal Commission. The initiative, which was supported by environmentalists and opposed by many developers, created a series of state and regional commissions tasked with creating a long-term plan for preserving California's coastal zones.<1>\nIn his memoir, Banowsky mistakenly recalls the vote as occurring on November 3 and also somehow (three pages later) on November 6, rather than November 7.<2> More reliable than his recall of dates is Banowsky's overall assessment: he notes that the new regulations would have made it nearly impossible to build the Malibu campus just months after it in fact opened. It is for this reason, among others, that the construction of the new campus has come to be called the \"Malibu Miracle,\" which Banowsky takes as the title of his memoir.\nPepperdine found its construction projects frozen in the fall of 1972, delaying work on the administration building (TAC) and Smothers Theatre for years. (Planning for the TAC began in 1972,<3> but construction wasn't completed until 1986.<4>)\nThe election date is not the only detail Banowsky fudges. He also writes that the miracle came off \"without filing any California environmental document,\" which might be technically correct, but |The Malibu Times| reported in August of the same year on an \"Environmental Impact Statement\" Pepperdine filed with the federal government, claiming the construction of the campus in Malibu would not harm the environment.<5>",
      sources: [
        {
          url: "",
          title: "Los Angeles Times",
          date: "11/8/72",
          publisher: "Otis Chandler",
          page: "A1, 17",
        },
        {
          url: "",
          title: "Banowsky",
          date: "2010",
          publisher: "Pepperdine University Press",
          page: "298, 301",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/3181/rec/81",
          title: "The Graphic",
          date: "10/13/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "457",
        },
        {
          url: "",
          title: "The Malibu Times",
          date: "8/4/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "politics"],
    seeAlso: {
      people: ["William S. Banowsky"],
      events: ["721013C"],
    },
  },
  {
    id: "721110B",
    title: "Karen Bua to lead cheerleaders",
    date: new Date("11/10/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "|The Graphic| reported that junior Karen Bua would lead Pepperdine's cheerleaders for the 1972-1973 academic year. Bua was a returning cheerleader from the LA campus for the '71-'72 year.<1> Tryouts had been held on campus at the end of October, with the student body being allowed to vote on who would make the squad.<2>\nBua would go on to marry Laker legend Jerry West.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7447/rec/2",
          title: "The Graphic",
          date: "11/10/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7718/rec/10",
          title: "The Graphic",
          date: "10/6/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["cheerleading", "student life"],
    seeAlso: {
      people: ["Karen Bua"],
      events: ["720428A", "730216A"],
    },
  },
  {
    id: "721117A",
    title: "Pepperdine accepts donated lighthouse",
    date: new Date("11/17/1972"),
    location: "Malibu",
    description: {
      text: "A Malibu resident worried about the demolition of a 50-foot-tall lighthouse offered the structure to Pepperdine, which accepted the donation. Officials had not yet decided where to place the structure, but one possibility was at the John Tyler entrance to the Malibu campus. The lighthouse had long been a landmark in the area, standing at 15100 PCH (on Will Rogers State Beach), but at no point had it ever shone a light to aid sailors' navigation.<1>\nThe structure was damaged while crews tried to move it, and it wound up spending several months on its side in a parking lot on campus.<2> A decade later, |The Graphic| reported that a maintenance vehicle had backed into the lighthouse, causing further damage to the termite-infested structure. The lighthouse, which never was erected on the campus, ended up in a landfill.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8603/rec/85",
          title: "The Graphic",
          date: "11/17/72",
          publisher: "Pepperdine University Archives",
          page: "1, 4",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/731/rec/19",
          title: "The Graphic",
          date: "6/8/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/841/rec/1",
          title: "The Graphic",
          date: "4/7/83",
          publisher: "Pepperdine University Archives",
          page: "A5",
        }
      ],
    },
    photo: {
      path: "/assets/Lighthouse.png",
      caption: "The lighthouse was damaged during the move.",
      source: {
        url: "https://pepperdine.contentdm.oclc.org/digital/collection/PUYB01/id/5315/rec/35",
        title: "iMprints, 1973",
        date: "8/3/73",
        publisher: "Pepperdine University Archives",
        page: "16",
      },
    },
    event: true,
    tags: ["donors"],
    seeAlso: {
      people: [],
      events: ["721006B", "721006E", "721103A"],
      stories: ["S72DONO"],
    },
  },
  {
    id: "721117B",
    title: "Guard booth planned for Seaver Drive",
    date: new Date("11/17/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "|The Graphic| reported that a security booth was in the works for the Seaver Drive entrance to the Malibu campus, just over two months after it opened. The security office was also hiring students to serve in part-time positions. The announcement came as welcome news to students seeking work in sparsely populated Malibu.<1>\nThe LA campus had recently gotten a guard booth of its own after a small crime wave in 1971.<2>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8604/rec/85",
          title: "The Graphic",
          date: "11/17/72",
          publisher: "Pepperdine University Archives",
          page: "2",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/953/rec/71",
          title: "The Graphic",
          date: "4/6/72",
          publisher: "Pepperdine University Archives",
          page: "4",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "security"],
    seeAlso: {
      people: [],
      events: ["720218A", "720406A", "721002A"],
      stories: ["S72SECU"]
    },
  },
  {
    id: "721117C",
    title: "Cable TV to be available in dorms soon",
    date: new Date("11/17/1972 14:00:00"),
    location: "Malibu",
    description: {
      text: "|The Graphic| reported that cable television would soon be available in dorm rooms, free of charge. Malibu provost Jerry Hudson explained that cable was being laid and would soon reach the dorms, but had been delayed by rain.<1>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8605/rec/85",
          title: "The Graphic",
          date: "11/17/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["construction", "housing"],
    seeAlso: {
      people: ["Jerry Hudson"],
      events: [],
      stories: ["S72MHSG"],
    },
  },
  {
    id: "721125A",
    title: "First basketball game of the season",
    date: new Date("11/25/1972 14:00:00"),
    location: "Culver City",
    description: {
      text: "In their first game of the 1972-1973 season, coach Gary Colson's Waves beat Doane University 101-90 behind an explosive performance by star William \"Bird\" Averitt. The junior's 43 points (including 16 in a row at one point) fell just shy of the school record of 44 set in 1953 by Bob Morris.<1> Averitt's 44 has not been surpassed since 1972, except by Averitt himself (five separate times in the 1972-1973 season).\n Averitt had help from freshman forward Dick Skophammer, who was allowed to play on the varsity squad thanks to a new rule instituted by the NCAA.<2> Skophammer contributed 10 points and 11 boards.<1>\nThe game took place at Veteran's Memorial Auditorium in Culver City, the Waves' home court while Firestone Fieldhouse was under construction. It took place directly after the men's volleyball game, which had to be cut short so the basketball game could start on time.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7288/rec/86",
          title: "The Graphic",
          date: "12/1/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/9881/rec/61",
          title: "The Graphic",
          date: "1/13/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7288/rec/86",
          title: "The Graphic",
          date: "12/1/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["Gary Colson", "William \"Bird\" Averitt"],
      events: ["720108B", "721016A", "721125B"],
    },
  },
  {
    id: "721125B",
    title: "First volleyball game of the season",
    date: new Date("11/25/1972 13:00:00"),
    location: "Culver City",
    description: {
      text: "Men's volleyball opened its 1972-1973 season with a match against LA Valley College that ended in a 2-2 tie, cut short to make way for the basketball game scheduled directly after. Junior Marv Dunphy (credited by |The Graphic| as Dumphy)<1> was making his debut as a Wave after transferring from Pierce College, where he had been team captain.<2>\nDunphy would go on to be the long-time coach of Pepperdine men's volleyball and a Waves legend of the first order.\nThe game took place at Veteran's Memorial Auditorium in Culver City, the Waves' home court while Firestone Fieldhouse was under construction.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/7288/rec/86",
          title: "The Graphic",
          date: "12/1/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6262/rec/3",
          title: "The Graphic",
          date: "6/22/72",
          publisher: "Pepperdine University Archives",
          page: "3",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/8608/rec/4",
          title: "The Graphic",
          date: "11/17/72",
          publisher: "Pepperdine University Archives",
          page: "6",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["athletics"],
    seeAlso: {
      people: ["Marv Dunphy"],
      events: ["720622B", "721125A"],
    },
  },
  {
    id: "721215A",
    title: "Fall commencement ceremony",
    date: new Date("12/15/1972"),
    location: "Santa Monica",
    description: {
      text: "Pepperdine's fall commencement exercises took place at the Santa Monica Civic Auditorium. Among the 261 graduating students were four from the Malibu campus,<1> including Gualberto Escudero,<2> who would go on to become the coach of Pepperdine's women's tennis team beginning in 1978 and lasting for 30 years.\nLess than seven months earlier, the Civic Auditorium had hosted the recording of comedian George Carlin's |Class Clown|, which featured the first performance of his famous \"Seven Words You Can Never Say on Television\" bit.",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13726/rec/745",
          title: "The Malibu Times",
          date: "12/29/72",
          publisher: "Pepperdine University Archives",
          page: "6",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/6703/rec/87",
          title: "The Graphic",
          date: "12/8/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["academics", "events"],
    seeAlso: {
      people: ["Gualberto Escudero"],
      events: [],
    },
  },
  {
    id: "721215B",
    title: "160 acres gifted to Pepperdine",
    date: new Date("12/15/1972 13:00:00"),
    location: "Malibu",
    description: {
      text: "Pepperdine received a gift of 160 acres adjacent to its hillside campus in Malibu. The land was donated by Seniel Ostrow, the president and owner of the Sealy Mattress Company.<1> |The Malibu Times| described the land as \"contiguous acreage\" that was \"northwest of the present campus.\"<1> The parcel lies due north of today's Drescher campus and includes the high hill where a white cross can be seen.\nThere were no definite plans for the land yet, though chancellor Norvel Young mentioned to |The Graphic| that it might be the location of a future business school. In the meantime, there was hope the land would serve as an extension of Malibu's equestrian program.<2>\nThis wasn't the first time Ostrow had donated land, and it wouldn't be the last. He gave 50 acres in 1969, with nine more following in 1981. That same year, president Howard White purchased 187 additional acres to the north and west of the campus, expanding Pepperdine to 819 acres. White came to refer to this last expansion as his Louisiana Purchase. Later donations brought the campus to its present total of 830 acres.<3>",
      sources: [
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP01/id/13237/rec/152",
          title: "The Malibu Times",
          date: "12/15/72",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "https://pepperdine.contentdm.oclc.org/digital/collection/PDNP05/id/78/rec/89",
          title: "The Graphic",
          date: "1/19/73",
          publisher: "Pepperdine University Archives",
          page: "1",
        },
        {
          url: "",
          title: "Baird",
          date: "2016",
          publisher: "Pepperdine University Press",
          page: "459",
        },
      ],
    },
    photo: null,
    event: true,
    tags: ["donors"],
    seeAlso: {
      people: ["Seniel Ostrow", "M. Norvel Young", "Howard A. White"],
      events: [],
      stories: ["S72DONO"],
    },
  },
];

/*
{
  id: "",
  title: "",
  date: new Date(""),
  location: "",
  description: {
    text: "",
    sources: [
      {
        url: "",
        title: "",
        date: "",
        publisher: "",
        page: "",
      },
    ],
  },
  photo: null,
  event: true,
  tags: [],
  seeAlso: {
    people: [],
    events: [],
  },
},
*/

export default events;